class TransfoError extends Error {
    constructor(message, type, cause) {
        super(cause ? `${message}\ncause: ${cause.message}` : message);
        this.type = type;
        this.cause = cause;
        this.name = "TransfoError";
    }
}

var helpers = {
// No helpers are included by default for the sake of size,
// But there's an example of a helper below
/*
  Date: function (args, content, blocks, options) {
    var today = new Date()
    var dd = today.getDate()
    var mm = today.getMonth() + 1 // January is 0!
    var yyyy = today.getFullYear()
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = mm + '/' + dd + '/' + yyyy
    return today
  } */
};

var Partials = {/*
    partialName: "partialString"
*/};

var initialRegEx = /{{ *?(?:(?:([\w$]+) *?\((.*?)\) *?([\w$]*))|(?:([\w$]+) *?\((.*?)\) *?\/)|(?:([\w$@].*?) *?((?:\| *?[\w$]+ *)*))|(?:\/ *?([\w$]+))|(?:# *?([\w$]+))|(?:!\-\-[^]+?\-\-)) *?}}\n?/g; // eslint-disable-line no-useless-escape
var initialTags = {
  s: '{{',
  e: '}}'
};

// The regExp below matches all helper references inside helper parameters
var paramHelperRefRegExp = /@(?:((?:\.\.\/)+)|([\w$]+):)?/g;

var regEx = initialRegEx;
var tags = initialTags;

function setup () {
  // Resets the current tags to the default tags
  tags = initialTags;
  regEx = initialRegEx;
  regEx.lastIndex = 0;
}

function changeTags (firstTag, secondTag) {
  // Update current tags
  var newRegEx =
    firstTag +
    regEx.source.slice(tags.s.length, 0 - (tags.e.length + 3)) +
    secondTag +
    '\\n?';
  var lastIndex = regEx.lastIndex;
  tags = {
    s: firstTag,
    e: secondTag
  };
  regEx = RegExp(newRegEx, 'g');
  regEx.lastIndex = lastIndex;
}

function replaceHelperRefs (str, helperArray, helperNumber) {
  return str.replace(paramHelperRefRegExp, function (m, scope, id) {
    var suffix;
    if (scope && scope.length) {
      suffix = helperArray[helperNumber - scope.length / 3 - 1].id;
    } else if (id) {
      suffix = id;
    } else {
      suffix = '';
    }
    return 'hvals' + suffix + '.'
  })
}

// The whole regular expression can be hard to comprehend, so here it's broken down.
// You can pass the string between "START REGEXP" and "END REGEXP" into a regular expression
// That removes whitespace and comments, and outputs a working regular expression.

/* START REGEXP
{{ *? //the beginning
(?: //or for each possible tag
(?:([\w$]+) *?\((.*?)\) *?([\w$]*)) //if a helper oTag
| //now for a self closing tag
(?:([\w$]+) *?\((.*?)\) *?\/)
| //now if a ref
(?: //if a global or helper ref
([\w$@].*?) *? //ref content
((?:\| *?[\w$]+ *)*) //filters
) //end if a global or helper ref
| //now if a helper cTag
(?:\/ *?([\w$]+))
| //now if a helper block
(?:# *?([\w$]+))
| //now for comments
(?:!\-\-[^]+?\-\-)
) //end or for each possible tag
 *?}}
\n? //To replace a newline at the end of a line

END REGEXP */
/*
p1: helper start name
p2: helper start params
p3: helper start id
p4: self-closing helper name
p5: self-closing helper params
p6: ref content
p7: ref filters
p8: helper close name
p9: helper block name
Here's the RegExp I use to turn the expanded version between START REGEXP and END REGEXP to a working one: I replace [^\S ]+| \/\/[\w ']+\n with "".
*/

var nativeHelpers = {
  if: {
    helperStart: function (param) { // helperStart is called with (params, id) but id isn't needed
      return 'if(' + param + '){'
    },
    helperEnd: function () {
      return '}'
    },
    blocks: {
      else: function () { // called with (id) but neither param is needed
        return '}else{'
      }
    }
  },
  each: {
    helperStart: function (param, id) { // helperStart is called with (params, id) but id isn't needed
      return 'for(var i=0;i<' + param + ".length; i++){tR+=(function(hvals){var tR='';var hvals" + id + '=hvals;'
    },
    helperEnd: function (param) {
      return 'return tR})({this:' + param + '[i],index:i})};'
    }
  },
  foreach: {
    helperStart: function (param, id) {
      return 'for(var key in ' + param + '){if(!' + param + ".hasOwnProperty(key)) continue;tR+=(function(hvals){var tR='';var hvals" + id + '=hvals;'
    },
    helperEnd: function (param) {
      return 'return tR})({this:' + param + '[key], key: key})};'
    }
  },
  log: {
    selfClosing: function (param) {
      return 'console.log(' + param + ');'
    }
  },
  tags: {
    selfClosing: function (param) {
      var firstTag = param.slice(0, param.indexOf(',')).trim();
      var secondTag = param.slice(param.indexOf(',') + 1).trim();
      changeTags(firstTag, secondTag);
      return ''
    }
  },
  js: { // The js self-closing helper allows you to inject JavaScript straight into your template function
    selfClosing: function (param) {
      return param + ';'
    }
  }
};

var escMap = {
  '&': '&amp;',
  '<': '&lt;',
  '"': '&quot;',
  "'": '&#39;'
};

function replaceChar (s) {
  return escMap[s]
}

var escapeRegEx = /[&<"']/g;
var escapeRegExTest = /[&<"']/;

var filters = {
  e: function (str) {
    // To deal with XSS. Based on Escape implementations of Mustache.JS and Marko, then customized.
    var newStr = String(str);
    if (escapeRegExTest.test(newStr)) {
      return newStr.replace(escapeRegEx, replaceChar)
    } else {
      return newStr
    }
  }
};

var defaultFilterCache = {
  // This is to prevent having to re-calculate default filters every time you return a filtered string
  start: '',
  end: ''
};

var autoEscape = true;
function parseFiltered (initialString, filterString) {
  var filtersArray;
  var safe = false;
  var filterStart = '';
  var filterEnd = '';
  if (filterString && filterString !== '') {
    filtersArray = filterString.split('|');
    for (var i = 0; i < filtersArray.length; i++) {
      filtersArray[i] = filtersArray[i].trim(); // Removing the spaces just in case someone put | filter| or | filter | or something similar
      if (filtersArray[i] === '') continue
      if (filtersArray[i] === 'safe') {
        // If 'safe' is one of the filters, set safe to true but don't add Sqrl.F.safe
        // Essentially, 'safe' is a flag telling Squirrelly not to autoEscape
        safe = true;
        continue
      }
      filterStart = 'Sqrl.F.' + filtersArray[i] + '(' + filterStart;
      filterEnd += ')';
    }
  }
  filterStart += defaultFilterCache.start;
  filterEnd += defaultFilterCache.end;
  if (!safe && autoEscape) {
    filterStart += 'Sqrl.F.e(';
    filterEnd += ')';
  }

  return filterStart + initialString + filterEnd
}

function Compile (str) {
  var lastIndex = 0; // Because lastIndex can be complicated, and this way the minifier can minify more
  var funcStr = "var tR='';"; // This will be called with Function() and returned
  var helperArray = []; // A list of all 'outstanding' helpers, or unclosed helpers
  var helperNumber = -1;
  var helperAutoId = 0; // Squirrelly automatically generates an ID for helpers that don't have a custom ID
  var helperContainsBlocks = {}; // If a helper contains any blocks, helperContainsBlocks[helperID] will be set to true
  var m;

  function addString (indx) {
    if (lastIndex !== indx) {
      funcStr +=
        "tR+='" +
        str
          .slice(lastIndex, indx)
          .replace(/\\/g, '\\\\')
          .replace(/'/g, "\\'") +
        "';";
    }
  }
  function ref (content, filters) {
    // console.log('refcontent: ' + content)
    // console.log('filters: ' + filters)
    var replaced = replaceHelperRefs(content, helperArray, helperNumber);

    if (content[0] === '@') {
      return parseFiltered(replaced, filters)
    }
    return parseFiltered('options.' + replaced, filters)
  }

  setup();
  while ((m = regEx.exec(str)) !== null) {
    addString(m.index); // Add the string between the last tag (or start of file) and the current tag
    lastIndex = m[0].length + m.index;

    if (m[1]) {
      // helper start. m[1] = helpername, m[2] = helper params, m[3] = id
      var id = m[3];
      if (id === '' || id === null) {
        id = helperAutoId;
        helperAutoId++;
      }
      var native = nativeHelpers.hasOwnProperty(m[1]); // true or false
      helperNumber += 1;
      var params = m[2] || '';
      params = replaceHelperRefs(params, helperArray, helperNumber);
      // console.log(params)
      if (!native) {
        params = '[' + params + ']';
      }
      var helperTag = {
        name: m[1],
        id: id,
        params: params,
        native: native
      };
      helperArray[helperNumber] = helperTag;
      if (native) {
        funcStr += nativeHelpers[m[1]].helperStart(params, id);
        lastIndex = regEx.lastIndex; // the changeTags function sets lastIndex already
      } else {
        funcStr +=
          'tR+=Sqrl.H.' +
          m[1] +
          '(' +
          params +
          ',function(hvals){var hvals' +
          id +
          "=hvals;var tR='';";
      }
    } else if (m[4]) {
      // self-closing helper. m[4] name, m[5] params
      // It's a self-closing helper
      var innerParams = m[5] || '';
      innerParams = replaceHelperRefs(innerParams, helperArray, helperNumber);
      if (m[4] === 'include') {
        // This code literally gets the template string up to the include self-closing helper,
        // adds the content of the partial, and adds the template string after the include self-closing helper
        var preContent = str.slice(0, m.index);
        var endContent = str.slice(m.index + m[0].length);
        var partialParams = innerParams.replace(/'|"/g, ''); // So people can write {{include(mypartial)/}} or {{include('mypartial')/}}
        var partialContent = Partials[partialParams];
        str = preContent + partialContent + endContent;
        lastIndex = regEx.lastIndex = m.index;
      } else if (
        nativeHelpers.hasOwnProperty(m[4]) &&
        nativeHelpers[m[4]].hasOwnProperty('selfClosing')
      ) {
        funcStr += nativeHelpers[m[4]].selfClosing(innerParams);
        lastIndex = regEx.lastIndex; // changeTags sets regEx.lastIndex
      } else {
        funcStr += 'tR+=Sqrl.H.' + m[4] + '(' + innerParams + ');'; // If it's not native, passing args to a non-native helper
      }
    } else if (m[6]) {
      // ref. m[6] content, m[7] filters
      funcStr += 'tR+=' + ref(m[6], m[7]) + ';';
    } else if (m[8]) {
      // helper close. m[8] name
      var mostRecentHelper = helperArray[helperNumber];
      if (mostRecentHelper && mostRecentHelper.name === m[8]) {
        helperNumber -= 1;
        if (mostRecentHelper.native === true) {
          funcStr += nativeHelpers[mostRecentHelper.name].helperEnd(
            mostRecentHelper.params,
            mostRecentHelper.id
          );
        } else {
          if (helperContainsBlocks[mostRecentHelper.id]) {
            funcStr += 'return tR}});';
          } else {
            funcStr += 'return tR});';
          }
        }
      } else {
        console.error("Helper beginning & end don't match.");
      }
    } else if (m[9]) {
      // helper block. m[9] name
      var parent = helperArray[helperNumber];
      if (parent.native) {
        var nativeH = nativeHelpers[parent.name];
        if (nativeH.blocks && nativeH.blocks[m[9]]) {
          funcStr += nativeH.blocks[m[9]](parent.id);
          lastIndex = regEx.lastIndex; // Some native helpers set regEx.lastIndex
        } else {
          console.warn(
            "Native helper '%s' doesn't accept that block.",
            parent.name
          );
        }
      } else {
        if (!helperContainsBlocks[parent.id]) {
          funcStr +=
            'return tR},{' +
            m[9] +
            ':function(hvals){var hvals' +
            parent.id +
            "=hvals;var tR='';";
          helperContainsBlocks[parent.id] = true;
        } else {
          funcStr +=
            'return tR},' +
            m[9] +
            ':function(hvals){var hvals' +
            parent.id +
            "=hvals;var tR='';";
        }
      }
    }
  }
  addString(str.length); // Add the string from the last tag-close to the end of the file, if there is one
  funcStr += 'return tR';
  var func = new Function( //eslint-disable-line
    'options',
    'Sqrl',
    funcStr.replace(/\n/g, '\\n').replace(/\r/g, '\\r')
  );
  return func
}

function Render (template, options) {
  // If the template parameter is a function, call that function with (options, squirrelly stuff)
  // If it's a string, first compile the string and then call the function
  if (typeof template === 'function') {
    return template(options, { H: helpers, F: filters, P: Partials })
  } else if (typeof template === 'string') {
    var res = load(options, template)(options, { H: helpers, F: filters, P: Partials });
    return res
  }
}

var cache = {};

function load (options, str) {
  var filePath = options.$file;
  var name = options.$name;
  var caching = options.$cache;

  if (filePath) {
    // If $file is passed in
    var fs = {};
    if (caching !== false) {
      if (!cache.hasOwnProperty(filePath)) {
        cache[filePath] = Compile(fs.readFileSync(filePath, 'utf8'));
      }
      return cache[filePath]
    } else {
      return Compile(fs.readFileSync(filePath, 'utf8'))
    }
  } else if (typeof str === 'string') {
    // If str is passed in
    if (name && caching !== false) {
      if (!cache.hasOwnProperty(name)) {
        cache[name] = Compile(str);
      }
      return cache[name]
    } else if (caching === true) {
      if (!cache.hasOwnProperty(str)) {
        cache[str] = Compile(str);
      }
      return cache[str]
    } else {
      return Compile(str)
    }
  } else if (name && caching !== false && cache.hasOwnProperty(name)) {
    // If only name is passed in and it exists in cache
    return cache[name]
  } else {
    // Neither $file nor str nor existing name is passed in
    return 'No template'
  }
}

function interpolateArguments(template, context) {
    const keys = Object.keys(template);
    const values = keys.map(k => template[k]);
    const interpolatedValues = interpolateArgumentsArray(values, context);
    const result = {};
    for (const i in keys)
        result[keys[i]] = interpolatedValues[i];
    return result;
}
function interpolateArgumentsArray(template, context) {
    try {
        return template.map(v => {
            return typeof v === 'string' && v.includes('{{') ? Render(v, context) : '' + v;
        });
    }
    catch (e) {
        throw new TransfoError(`Error interpolating values`, 1 /* TransfoErrorType.INTERPOLATING_ERROR */, e);
    }
}

function runFormula(registry, formula, context) {
    if (!registry[formula.name])
        console.error('Formula not found: ', formula.name);
    const args = interpolateArguments(formula.arguments, context);
    const instance = registry[formula.name];
    return validateAndGenerate(instance, args);
}
function validateAndGenerate(formula, args) {
    validateArgs(formula, args);
    try {
        return formula.generate(args);
    }
    catch (e) {
        console.error(e);
        throw new TransfoError(`Error while running formula ${formula.name}`, 0 /* TransfoErrorType.FORMULA_ERROR */, e);
    }
}
function validateArgs(formula, args) {
    for (const key of formula.required) {
        if (args[key] === undefined)
            throw new TransfoError(`Required key missing in formula ${formula.name}, key: ${key}`, 2 /* TransfoErrorType.FORMULA_VALIDATION_ERROR */);
    }
    for (const key in args) {
        if (formula.args.indexOf(key) < 0)
            throw new TransfoError(`Unknown key in formula ${formula.name}, key: ${key}`, 2 /* TransfoErrorType.FORMULA_VALIDATION_ERROR */);
    }
}

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return Object.propertyIsEnumerable.call(target, symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

function link(groups, transformations, mutations, formulaRegistry) {
    const nameTransformationMap = new Map();
    for (const transformation of transformations) {
        nameTransformationMap.set(transformation.name, transformation);
    }
    const nameGroupMap = new Map();
    for (const group of groups) {
        nameGroupMap.set(group.expandedName, group);
    }
    const matcherTransformationsMap = new Map();
    for (const preMutation of mutations) {
        if (preMutation.transformations.length <= 0)
            console.warn('Mutation with no transformations');
        const mutation = {
            matchers: preMutation.matchers.map(m => {
                const preGroup = nameGroupMap.get(m.group);
                if (!preGroup) {
                    console.warn('Group not found', m.group);
                    return { group: undefined };
                }
                else {
                    return { group: preGroup };
                }
            }),
            transformations: preMutation.transformations.map(t => {
                return {
                    transformation: nameTransformationMap.get(t.name),
                    arguments: t.arguments
                };
            })
        };
        for (const matcher of mutation.matchers) {
            matcherTransformationsMap.set(matcher, [...mutation.transformations, ...(matcherTransformationsMap.get(matcher) || [])]);
        }
    }
    const instructions = new Map();
    matcherTransformationsMap.forEach((ts, m) => {
        const instruction = {};
        ts.forEach(t => {
            const context = {
                t: t.arguments || {}
            };
            const effects = (t.transformation.effects || []).map(e => {
                const effect = JSON.parse(JSON.stringify(e));
                effect.attributes = interpolateArguments(effect.attributes || {}, context);
                effect.elements = (effect.elements || []).map(el => {
                    el.attributes = interpolateArguments(el.attributes, context);
                    return el;
                });
                return effect;
            });
            const css = interpolateArguments(t.transformation.css || {}, context);
            const filterAttributes = interpolateArguments(t.transformation.filterAttributes || {}, context);
            const clipPath = t.transformation.clipPath;
            const moreInstructions = [{ effects, css, filterAttributes, clipPath }];
            if (t.transformation.formulas) {
                t.transformation.formulas.forEach(formula => {
                    moreInstructions.push(runFormula(formulaRegistry, formula, context));
                });
            }
            moreInstructions.forEach(i => mergeInstructions(instruction, i));
        });
        instructions.set(m, instruction);
    });
    return instructions;
}
function mergeInstructions(target, source) {
    target.effects = (target.effects || []).concat(source.effects || []);
    target.css = cjs(target.css || {}, source.css || {});
    target.filterAttributes = cjs(target.filterAttributes || {}, source.filterAttributes || {});
    target.clipPath = target.clipPath || source.clipPath;
}

function hash(str) {
    var hash = 0, i, chr;
    if (str.length === 0)
        return hash;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash.toString(16).substr(1);
}

var ChoiceMode;
(function (ChoiceMode) {
    ChoiceMode["Delete"] = "delete";
    ChoiceMode["DisplayNone"] = "display_none";
})(ChoiceMode || (ChoiceMode = {}));

function flat(arr) {
    return arr.reduce((r, a) => r.concat(a), []);
}

function modifyDom(parseResult, instructions, groupChoices, choiceMode, baseUrl = '', elementsCache) {
    const { root, rootElement, createElement, $ } = parseResult;
    let defsElement = rootElement.find('defs#transfo-defs');
    let descElement = rootElement.find('desc#transfo-desc');
    defsElement = defsElement.length ? defsElement : createElement('defs').prependTo(rootElement).attr('id', 'transfo-defs');
    descElement = descElement.length ? descElement : createElement('desc').text('Transformed by Transfo').prependTo(rootElement).attr('id', 'transfo-desc');
    let areChoicesMade = false;
    const allDeleted = [];
    function hideNodes(list) {
        for (const el of list) {
            if (choiceMode == ChoiceMode.Delete) {
                el.remove();
            }
            else {
                el.attr('transfo-hidden', 'true');
                el.css('display', 'none');
            }
        }
    }
    function showNodes(list) {
        for (const el of list) {
            if (choiceMode == ChoiceMode.DisplayNone) {
                el.removeAttr('transfo-hidden');
                el.css('display', '');
            }
        }
    }
    function findInRoot(expandedName) {
        if (elementsCache) {
            const el = elementsCache.get(expandedName);
            if (el)
                return el;
        }
        const el = findNodeListByExpandedName($, root, expandedName);
        // const el = root.find(selectorByName(expandedName));
        if (elementsCache)
            elementsCache.set(expandedName, el);
        return el;
    }
    groupChoices.forEach(({ chosen, unchosen, defaults }) => {
        if (chosen.length && unchosen.length)
            areChoicesMade = true;
        unchosen.forEach(group => {
            const list = findInRoot(group.expandedName);
            allDeleted.push(group);
            hideNodes(list);
        });
        /** Decides whether the default group will be shown or not */
        let hasAnExistingChosenGroup = false;
        chosen.forEach(group => {
            const list = findInRoot(group.expandedName);
            if (!isNodeListEmpty(list))
                hasAnExistingChosenGroup = true;
            if (choiceMode == ChoiceMode.DisplayNone) {
                showNodes(list);
            }
        });
        defaults.forEach(group => {
            const list = findInRoot(group.expandedName);
            if (hasAnExistingChosenGroup) {
                allDeleted.push(group);
                hideNodes(list);
            }
            else if (choiceMode == ChoiceMode.DisplayNone) {
                showNodes(list);
            }
        });
    });
    instructions.forEach((instruction, m) => {
        if (areChoicesMade && allDeleted.includes(m.group))
            return;
        const groupElements = findInRoot(m.group.expandedName);
        if (groupElements.length <= 0)
            return;
        const { effects, css, filterAttributes, clipPath } = instruction;
        let filterId;
        if (effects && effects.length > 0) {
            filterId = `tf-filter-${hash(JSON.stringify([m.group.expandedName, instruction]))}`;
            const filterElement = createElement('filter').appendTo(defsElement)
                .attr('id', filterId)
                .attr('filterUnits', 'objectBoundingBox')
                .attr('primitiveUnits', 'userSpaceOnUse')
                .attr('color-interpolation-filters', 'linearRGB');
            for (const filterAttrKey in filterAttributes) {
                filterElement.attr(filterAttrKey, '' + filterAttributes[filterAttrKey]);
            }
            for (const effect of effects) {
                const effectElement = createElement(effect.tag).appendTo(filterElement);
                for (const attributeName in effect.attributes) {
                    effectElement.attr(attributeName, '' + effect.attributes[attributeName]);
                }
                if (effect.elements) {
                    for (const effectSubEl of effect.elements) {
                        const se = createElement(effectSubEl.tag).appendTo(effectElement);
                        for (const attributeName in effectSubEl.attributes) {
                            se.attr(attributeName, '' + effectSubEl.attributes[attributeName]);
                        }
                    }
                }
            }
        }
        for (const groupElement of groupElements) {
            if (filterId) {
                groupElement.attr('filter', `url(${baseUrl}#${filterId})`);
            }
            else {
                groupElement.removeAttr('filter');
            }
            for (const cssKey in css) {
                groupElement.css(cssKey, css[cssKey]);
            }
            if (clipPath) {
                const clipPathGroup = getFirstElementInNodeList($, findNodeListByExpandedName($, root, clipPath.group));
                let id = clipPath.preserveId ? clipPathGroup.attr('id') : undefined;
                const clipPathElement = clipPath.fromGroup ? createElement('clipPath') : clipPathGroup;
                // Allowed elements in clip paths: <circle>, <ellipse>, <line>, <mesh>, <path>, <polygon>, <polyline>, <rect>
                // From https://developer.mozilla.org/en-US/docs/Web/SVG/Element/clipPath
                const ALLOWED_CLIP_PATH_TAGS = 'circle, ellipse, line, mesh, path, polygon, polyline, rect';
                let clipPathSubElements;
                if (choiceMode == ChoiceMode.Delete) {
                    clipPathSubElements = clipPathGroup.find(ALLOWED_CLIP_PATH_TAGS);
                }
                else {
                    const tempClipPathGroup = clipPathGroup.clone();
                    tempClipPathGroup.find('[transfo-hidden]').remove();
                    clipPathSubElements = tempClipPathGroup.find(ALLOWED_CLIP_PATH_TAGS);
                }
                // Don't be destructive to original element
                if (choiceMode == ChoiceMode.DisplayNone)
                    clipPathSubElements = clipPathSubElements.clone();
                clipPathSubElements.appendTo(clipPathElement);
                // clipPathGroup.remove();
                hideNodes([clipPathGroup]);
                id = id || `tf-clip-path-${hash(clipPath.group + clipPathElement.html())}`;
                clipPathElement.attr('id', id)
                    .attr('transfo-from-group', clipPath.group)
                    .prependTo(defsElement);
                groupElement.attr('clip-path', `url(${baseUrl}#${id})`);
            }
        }
    });
}
const TRANSFO_ID_ATTRS = ['transfo-id', 'id'];
const TRANSFO_INVISIBLE_ATTRS = ['transfo-invisible'];
// // TODO: can be improved
// export const selector = (group: ExpandedGroup) => {
//   return selectorByName(group.expandedName);
// }
// export const selectorByName = (name: string) => {
//   const parts = name.split('/');
//   return TRANSFO_ID_ATTRS.map(
//     (attr) => parts.map(p => `[${attr}="${p}"]`).join(' > ')
//   ).join(', ');
// }
// export const findNodeListByExpandedNameLegacy = ($: CheerioAPI, el: Cheerio<AnyNode>, name: string): NodeList => {
//   return [el.find(selectorByName(name))];
// }
const findNodeListByExpandedName = ($, el, name) => {
    const parts = name.split('/');
    return findNodeListByExpandedNameParts($, el, parts);
};
const findNodeListByExpandedNameParts = ($, el, parts) => {
    const qualifyingDirectChildren = findElementDirectChildren($, el).filter((e) => {
        const childEl = $(e);
        const attrVal = TRANSFO_ID_ATTRS.map((attr) => childEl.attr(attr)).find((attrVal) => !!attrVal);
        return attrVal === parts[0];
    });
    const results = qualifyingDirectChildren.map((childEl) => {
        return parts.length > 1 ? findNodeListByExpandedNameParts($, childEl, parts.slice(1)) : [childEl];
    });
    return flat(results);
};
const findElementDirectChildren = ($, el) => {
    // direct children are like this selector:
    // `parent/**[transfo-invisible]/direct_child`
    let directChildren = [];
    el.children().each((i, e) => {
        const childEl = $(e);
        if (TRANSFO_INVISIBLE_ATTRS.some((sel) => childEl.attr(sel) !== undefined)) {
            // if the child is invisible, keep looking for children inside the child
            directChildren = [...directChildren, ...findElementDirectChildren($, childEl)];
        }
        else if (TRANSFO_ID_ATTRS.some((sel) => childEl.attr(sel) !== undefined)) {
            directChildren.push(childEl);
        }
    });
    return directChildren;
};
const isNodeListEmpty = (list) => {
    for (const el of list) {
        if (el.length > 0) {
            return false;
        }
    }
    return true;
};
const getFirstElementInNodeList = ($, list) => {
    for (const el of list) {
        if (el.length > 0) {
            return $(el[0]);
        }
    }
};

var empty = {};

var utils$8 = {};

(function (exports) {

	exports.isInteger = num => {
	  if (typeof num === 'number') {
	    return Number.isInteger(num);
	  }
	  if (typeof num === 'string' && num.trim() !== '') {
	    return Number.isInteger(Number(num));
	  }
	  return false;
	};

	/**
	 * Find a node of the given type
	 */

	exports.find = (node, type) => node.nodes.find(node => node.type === type);

	/**
	 * Find a node of the given type
	 */

	exports.exceedsLimit = (min, max, step = 1, limit) => {
	  if (limit === false) return false;
	  if (!exports.isInteger(min) || !exports.isInteger(max)) return false;
	  return ((Number(max) - Number(min)) / Number(step)) >= limit;
	};

	/**
	 * Escape the given node with '\\' before node.value
	 */

	exports.escapeNode = (block, n = 0, type) => {
	  let node = block.nodes[n];
	  if (!node) return;

	  if ((type && node.type === type) || node.type === 'open' || node.type === 'close') {
	    if (node.escaped !== true) {
	      node.value = '\\' + node.value;
	      node.escaped = true;
	    }
	  }
	};

	/**
	 * Returns true if the given brace node should be enclosed in literal braces
	 */

	exports.encloseBrace = node => {
	  if (node.type !== 'brace') return false;
	  if ((node.commas >> 0 + node.ranges >> 0) === 0) {
	    node.invalid = true;
	    return true;
	  }
	  return false;
	};

	/**
	 * Returns true if a brace node is invalid.
	 */

	exports.isInvalidBrace = block => {
	  if (block.type !== 'brace') return false;
	  if (block.invalid === true || block.dollar) return true;
	  if ((block.commas >> 0 + block.ranges >> 0) === 0) {
	    block.invalid = true;
	    return true;
	  }
	  if (block.open !== true || block.close !== true) {
	    block.invalid = true;
	    return true;
	  }
	  return false;
	};

	/**
	 * Returns true if a node is an open or close node
	 */

	exports.isOpenOrClose = node => {
	  if (node.type === 'open' || node.type === 'close') {
	    return true;
	  }
	  return node.open === true || node.close === true;
	};

	/**
	 * Reduce an array of text nodes.
	 */

	exports.reduce = nodes => nodes.reduce((acc, node) => {
	  if (node.type === 'text') acc.push(node.value);
	  if (node.type === 'range') node.type = 'text';
	  return acc;
	}, []);

	/**
	 * Flatten an array
	 */

	exports.flatten = (...args) => {
	  const result = [];
	  const flat = arr => {
	    for (let i = 0; i < arr.length; i++) {
	      let ele = arr[i];
	      Array.isArray(ele) ? flat(ele) : ele !== void 0 && result.push(ele);
	    }
	    return result;
	  };
	  flat(args);
	  return result;
	};
} (utils$8));

const utils$7 = utils$8;

var stringify$4 = (ast, options = {}) => {
  let stringify = (node, parent = {}) => {
    let invalidBlock = options.escapeInvalid && utils$7.isInvalidBrace(parent);
    let invalidNode = node.invalid === true && options.escapeInvalid === true;
    let output = '';

    if (node.value) {
      if ((invalidBlock || invalidNode) && utils$7.isOpenOrClose(node)) {
        return '\\' + node.value;
      }
      return node.value;
    }

    if (node.value) {
      return node.value;
    }

    if (node.nodes) {
      for (let child of node.nodes) {
        output += stringify(child);
      }
    }
    return output;
  };

  return stringify(ast);
};

/*!
 * is-number <https://github.com/jonschlinkert/is-number>
 *
 * Copyright (c) 2014-present, Jon Schlinkert.
 * Released under the MIT License.
 */

var isNumber$2 = function(num) {
  if (typeof num === 'number') {
    return num - num === 0;
  }
  if (typeof num === 'string' && num.trim() !== '') {
    return Number.isFinite ? Number.isFinite(+num) : isFinite(+num);
  }
  return false;
};

/*!
 * to-regex-range <https://github.com/micromatch/to-regex-range>
 *
 * Copyright (c) 2015-present, Jon Schlinkert.
 * Released under the MIT License.
 */

const isNumber$1 = isNumber$2;

const toRegexRange$1 = (min, max, options) => {
  if (isNumber$1(min) === false) {
    throw new TypeError('toRegexRange: expected the first argument to be a number');
  }

  if (max === void 0 || min === max) {
    return String(min);
  }

  if (isNumber$1(max) === false) {
    throw new TypeError('toRegexRange: expected the second argument to be a number.');
  }

  let opts = { relaxZeros: true, ...options };
  if (typeof opts.strictZeros === 'boolean') {
    opts.relaxZeros = opts.strictZeros === false;
  }

  let relax = String(opts.relaxZeros);
  let shorthand = String(opts.shorthand);
  let capture = String(opts.capture);
  let wrap = String(opts.wrap);
  let cacheKey = min + ':' + max + '=' + relax + shorthand + capture + wrap;

  if (toRegexRange$1.cache.hasOwnProperty(cacheKey)) {
    return toRegexRange$1.cache[cacheKey].result;
  }

  let a = Math.min(min, max);
  let b = Math.max(min, max);

  if (Math.abs(a - b) === 1) {
    let result = min + '|' + max;
    if (opts.capture) {
      return `(${result})`;
    }
    if (opts.wrap === false) {
      return result;
    }
    return `(?:${result})`;
  }

  let isPadded = hasPadding(min) || hasPadding(max);
  let state = { min, max, a, b };
  let positives = [];
  let negatives = [];

  if (isPadded) {
    state.isPadded = isPadded;
    state.maxLen = String(state.max).length;
  }

  if (a < 0) {
    let newMin = b < 0 ? Math.abs(b) : 1;
    negatives = splitToPatterns(newMin, Math.abs(a), state, opts);
    a = state.a = 0;
  }

  if (b >= 0) {
    positives = splitToPatterns(a, b, state, opts);
  }

  state.negatives = negatives;
  state.positives = positives;
  state.result = collatePatterns(negatives, positives);

  if (opts.capture === true) {
    state.result = `(${state.result})`;
  } else if (opts.wrap !== false && (positives.length + negatives.length) > 1) {
    state.result = `(?:${state.result})`;
  }

  toRegexRange$1.cache[cacheKey] = state;
  return state.result;
};

function collatePatterns(neg, pos, options) {
  let onlyNegative = filterPatterns(neg, pos, '-', false) || [];
  let onlyPositive = filterPatterns(pos, neg, '', false) || [];
  let intersected = filterPatterns(neg, pos, '-?', true) || [];
  let subpatterns = onlyNegative.concat(intersected).concat(onlyPositive);
  return subpatterns.join('|');
}

function splitToRanges(min, max) {
  let nines = 1;
  let zeros = 1;

  let stop = countNines(min, nines);
  let stops = new Set([max]);

  while (min <= stop && stop <= max) {
    stops.add(stop);
    nines += 1;
    stop = countNines(min, nines);
  }

  stop = countZeros(max + 1, zeros) - 1;

  while (min < stop && stop <= max) {
    stops.add(stop);
    zeros += 1;
    stop = countZeros(max + 1, zeros) - 1;
  }

  stops = [...stops];
  stops.sort(compare);
  return stops;
}

/**
 * Convert a range to a regex pattern
 * @param {Number} `start`
 * @param {Number} `stop`
 * @return {String}
 */

function rangeToPattern(start, stop, options) {
  if (start === stop) {
    return { pattern: start, count: [], digits: 0 };
  }

  let zipped = zip(start, stop);
  let digits = zipped.length;
  let pattern = '';
  let count = 0;

  for (let i = 0; i < digits; i++) {
    let [startDigit, stopDigit] = zipped[i];

    if (startDigit === stopDigit) {
      pattern += startDigit;

    } else if (startDigit !== '0' || stopDigit !== '9') {
      pattern += toCharacterClass(startDigit, stopDigit);

    } else {
      count++;
    }
  }

  if (count) {
    pattern += options.shorthand === true ? '\\d' : '[0-9]';
  }

  return { pattern, count: [count], digits };
}

function splitToPatterns(min, max, tok, options) {
  let ranges = splitToRanges(min, max);
  let tokens = [];
  let start = min;
  let prev;

  for (let i = 0; i < ranges.length; i++) {
    let max = ranges[i];
    let obj = rangeToPattern(String(start), String(max), options);
    let zeros = '';

    if (!tok.isPadded && prev && prev.pattern === obj.pattern) {
      if (prev.count.length > 1) {
        prev.count.pop();
      }

      prev.count.push(obj.count[0]);
      prev.string = prev.pattern + toQuantifier(prev.count);
      start = max + 1;
      continue;
    }

    if (tok.isPadded) {
      zeros = padZeros(max, tok, options);
    }

    obj.string = zeros + obj.pattern + toQuantifier(obj.count);
    tokens.push(obj);
    start = max + 1;
    prev = obj;
  }

  return tokens;
}

function filterPatterns(arr, comparison, prefix, intersection, options) {
  let result = [];

  for (let ele of arr) {
    let { string } = ele;

    // only push if _both_ are negative...
    if (!intersection && !contains(comparison, 'string', string)) {
      result.push(prefix + string);
    }

    // or _both_ are positive
    if (intersection && contains(comparison, 'string', string)) {
      result.push(prefix + string);
    }
  }
  return result;
}

/**
 * Zip strings
 */

function zip(a, b) {
  let arr = [];
  for (let i = 0; i < a.length; i++) arr.push([a[i], b[i]]);
  return arr;
}

function compare(a, b) {
  return a > b ? 1 : b > a ? -1 : 0;
}

function contains(arr, key, val) {
  return arr.some(ele => ele[key] === val);
}

function countNines(min, len) {
  return Number(String(min).slice(0, -len) + '9'.repeat(len));
}

function countZeros(integer, zeros) {
  return integer - (integer % Math.pow(10, zeros));
}

function toQuantifier(digits) {
  let [start = 0, stop = ''] = digits;
  if (stop || start > 1) {
    return `{${start + (stop ? ',' + stop : '')}}`;
  }
  return '';
}

function toCharacterClass(a, b, options) {
  return `[${a}${(b - a === 1) ? '' : '-'}${b}]`;
}

function hasPadding(str) {
  return /^-?(0+)\d/.test(str);
}

function padZeros(value, tok, options) {
  if (!tok.isPadded) {
    return value;
  }

  let diff = Math.abs(tok.maxLen - String(value).length);
  let relax = options.relaxZeros !== false;

  switch (diff) {
    case 0:
      return '';
    case 1:
      return relax ? '0?' : '0';
    case 2:
      return relax ? '0{0,2}' : '00';
    default: {
      return relax ? `0{0,${diff}}` : `0{${diff}}`;
    }
  }
}

/**
 * Cache
 */

toRegexRange$1.cache = {};
toRegexRange$1.clearCache = () => (toRegexRange$1.cache = {});

/**
 * Expose `toRegexRange`
 */

var toRegexRange_1 = toRegexRange$1;

/*!
 * fill-range <https://github.com/jonschlinkert/fill-range>
 *
 * Copyright (c) 2014-present, Jon Schlinkert.
 * Licensed under the MIT License.
 */

const util$1 = empty;
const toRegexRange = toRegexRange_1;

const isObject$1 = val => val !== null && typeof val === 'object' && !Array.isArray(val);

const transform = toNumber => {
  return value => toNumber === true ? Number(value) : String(value);
};

const isValidValue = value => {
  return typeof value === 'number' || (typeof value === 'string' && value !== '');
};

const isNumber = num => Number.isInteger(+num);

const zeros = input => {
  let value = `${input}`;
  let index = -1;
  if (value[0] === '-') value = value.slice(1);
  if (value === '0') return false;
  while (value[++index] === '0');
  return index > 0;
};

const stringify$3 = (start, end, options) => {
  if (typeof start === 'string' || typeof end === 'string') {
    return true;
  }
  return options.stringify === true;
};

const pad = (input, maxLength, toNumber) => {
  if (maxLength > 0) {
    let dash = input[0] === '-' ? '-' : '';
    if (dash) input = input.slice(1);
    input = (dash + input.padStart(dash ? maxLength - 1 : maxLength, '0'));
  }
  if (toNumber === false) {
    return String(input);
  }
  return input;
};

const toMaxLen = (input, maxLength) => {
  let negative = input[0] === '-' ? '-' : '';
  if (negative) {
    input = input.slice(1);
    maxLength--;
  }
  while (input.length < maxLength) input = '0' + input;
  return negative ? ('-' + input) : input;
};

const toSequence = (parts, options) => {
  parts.negatives.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);
  parts.positives.sort((a, b) => a < b ? -1 : a > b ? 1 : 0);

  let prefix = options.capture ? '' : '?:';
  let positives = '';
  let negatives = '';
  let result;

  if (parts.positives.length) {
    positives = parts.positives.join('|');
  }

  if (parts.negatives.length) {
    negatives = `-(${prefix}${parts.negatives.join('|')})`;
  }

  if (positives && negatives) {
    result = `${positives}|${negatives}`;
  } else {
    result = positives || negatives;
  }

  if (options.wrap) {
    return `(${prefix}${result})`;
  }

  return result;
};

const toRange = (a, b, isNumbers, options) => {
  if (isNumbers) {
    return toRegexRange(a, b, { wrap: false, ...options });
  }

  let start = String.fromCharCode(a);
  if (a === b) return start;

  let stop = String.fromCharCode(b);
  return `[${start}-${stop}]`;
};

const toRegex = (start, end, options) => {
  if (Array.isArray(start)) {
    let wrap = options.wrap === true;
    let prefix = options.capture ? '' : '?:';
    return wrap ? `(${prefix}${start.join('|')})` : start.join('|');
  }
  return toRegexRange(start, end, options);
};

const rangeError = (...args) => {
  return new RangeError('Invalid range arguments: ' + util$1.inspect(...args));
};

const invalidRange = (start, end, options) => {
  if (options.strictRanges === true) throw rangeError([start, end]);
  return [];
};

const invalidStep = (step, options) => {
  if (options.strictRanges === true) {
    throw new TypeError(`Expected step "${step}" to be a number`);
  }
  return [];
};

const fillNumbers = (start, end, step = 1, options = {}) => {
  let a = Number(start);
  let b = Number(end);

  if (!Number.isInteger(a) || !Number.isInteger(b)) {
    if (options.strictRanges === true) throw rangeError([start, end]);
    return [];
  }

  // fix negative zero
  if (a === 0) a = 0;
  if (b === 0) b = 0;

  let descending = a > b;
  let startString = String(start);
  let endString = String(end);
  let stepString = String(step);
  step = Math.max(Math.abs(step), 1);

  let padded = zeros(startString) || zeros(endString) || zeros(stepString);
  let maxLen = padded ? Math.max(startString.length, endString.length, stepString.length) : 0;
  let toNumber = padded === false && stringify$3(start, end, options) === false;
  let format = options.transform || transform(toNumber);

  if (options.toRegex && step === 1) {
    return toRange(toMaxLen(start, maxLen), toMaxLen(end, maxLen), true, options);
  }

  let parts = { negatives: [], positives: [] };
  let push = num => parts[num < 0 ? 'negatives' : 'positives'].push(Math.abs(num));
  let range = [];
  let index = 0;

  while (descending ? a >= b : a <= b) {
    if (options.toRegex === true && step > 1) {
      push(a);
    } else {
      range.push(pad(format(a, index), maxLen, toNumber));
    }
    a = descending ? a - step : a + step;
    index++;
  }

  if (options.toRegex === true) {
    return step > 1
      ? toSequence(parts, options)
      : toRegex(range, null, { wrap: false, ...options });
  }

  return range;
};

const fillLetters = (start, end, step = 1, options = {}) => {
  if ((!isNumber(start) && start.length > 1) || (!isNumber(end) && end.length > 1)) {
    return invalidRange(start, end, options);
  }


  let format = options.transform || (val => String.fromCharCode(val));
  let a = `${start}`.charCodeAt(0);
  let b = `${end}`.charCodeAt(0);

  let descending = a > b;
  let min = Math.min(a, b);
  let max = Math.max(a, b);

  if (options.toRegex && step === 1) {
    return toRange(min, max, false, options);
  }

  let range = [];
  let index = 0;

  while (descending ? a >= b : a <= b) {
    range.push(format(a, index));
    a = descending ? a - step : a + step;
    index++;
  }

  if (options.toRegex === true) {
    return toRegex(range, null, { wrap: false, options });
  }

  return range;
};

const fill$2 = (start, end, step, options = {}) => {
  if (end == null && isValidValue(start)) {
    return [start];
  }

  if (!isValidValue(start) || !isValidValue(end)) {
    return invalidRange(start, end, options);
  }

  if (typeof step === 'function') {
    return fill$2(start, end, 1, { transform: step });
  }

  if (isObject$1(step)) {
    return fill$2(start, end, 0, step);
  }

  let opts = { ...options };
  if (opts.capture === true) opts.wrap = true;
  step = step || opts.step || 1;

  if (!isNumber(step)) {
    if (step != null && !isObject$1(step)) return invalidStep(step, opts);
    return fill$2(start, end, 1, step);
  }

  if (isNumber(start) && isNumber(end)) {
    return fillNumbers(start, end, step, opts);
  }

  return fillLetters(start, end, Math.max(Math.abs(step), 1), opts);
};

var fillRange = fill$2;

const fill$1 = fillRange;
const utils$6 = utils$8;

const compile$1 = (ast, options = {}) => {
  let walk = (node, parent = {}) => {
    let invalidBlock = utils$6.isInvalidBrace(parent);
    let invalidNode = node.invalid === true && options.escapeInvalid === true;
    let invalid = invalidBlock === true || invalidNode === true;
    let prefix = options.escapeInvalid === true ? '\\' : '';
    let output = '';

    if (node.isOpen === true) {
      return prefix + node.value;
    }
    if (node.isClose === true) {
      return prefix + node.value;
    }

    if (node.type === 'open') {
      return invalid ? (prefix + node.value) : '(';
    }

    if (node.type === 'close') {
      return invalid ? (prefix + node.value) : ')';
    }

    if (node.type === 'comma') {
      return node.prev.type === 'comma' ? '' : (invalid ? node.value : '|');
    }

    if (node.value) {
      return node.value;
    }

    if (node.nodes && node.ranges > 0) {
      let args = utils$6.reduce(node.nodes);
      let range = fill$1(...args, { ...options, wrap: false, toRegex: true });

      if (range.length !== 0) {
        return args.length > 1 && range.length > 1 ? `(${range})` : range;
      }
    }

    if (node.nodes) {
      for (let child of node.nodes) {
        output += walk(child, node);
      }
    }
    return output;
  };

  return walk(ast);
};

var compile_1 = compile$1;

const fill = fillRange;
const stringify$2 = stringify$4;
const utils$5 = utils$8;

const append = (queue = '', stash = '', enclose = false) => {
  let result = [];

  queue = [].concat(queue);
  stash = [].concat(stash);

  if (!stash.length) return queue;
  if (!queue.length) {
    return enclose ? utils$5.flatten(stash).map(ele => `{${ele}}`) : stash;
  }

  for (let item of queue) {
    if (Array.isArray(item)) {
      for (let value of item) {
        result.push(append(value, stash, enclose));
      }
    } else {
      for (let ele of stash) {
        if (enclose === true && typeof ele === 'string') ele = `{${ele}}`;
        result.push(Array.isArray(ele) ? append(item, ele, enclose) : (item + ele));
      }
    }
  }
  return utils$5.flatten(result);
};

const expand$1 = (ast, options = {}) => {
  let rangeLimit = options.rangeLimit === void 0 ? 1000 : options.rangeLimit;

  let walk = (node, parent = {}) => {
    node.queue = [];

    let p = parent;
    let q = parent.queue;

    while (p.type !== 'brace' && p.type !== 'root' && p.parent) {
      p = p.parent;
      q = p.queue;
    }

    if (node.invalid || node.dollar) {
      q.push(append(q.pop(), stringify$2(node, options)));
      return;
    }

    if (node.type === 'brace' && node.invalid !== true && node.nodes.length === 2) {
      q.push(append(q.pop(), ['{}']));
      return;
    }

    if (node.nodes && node.ranges > 0) {
      let args = utils$5.reduce(node.nodes);

      if (utils$5.exceedsLimit(...args, options.step, rangeLimit)) {
        throw new RangeError('expanded array length exceeds range limit. Use options.rangeLimit to increase or disable the limit.');
      }

      let range = fill(...args, options);
      if (range.length === 0) {
        range = stringify$2(node, options);
      }

      q.push(append(q.pop(), range));
      node.nodes = [];
      return;
    }

    let enclose = utils$5.encloseBrace(node);
    let queue = node.queue;
    let block = node;

    while (block.type !== 'brace' && block.type !== 'root' && block.parent) {
      block = block.parent;
      queue = block.queue;
    }

    for (let i = 0; i < node.nodes.length; i++) {
      let child = node.nodes[i];

      if (child.type === 'comma' && node.type === 'brace') {
        if (i === 1) queue.push('');
        queue.push('');
        continue;
      }

      if (child.type === 'close') {
        q.push(append(q.pop(), queue, enclose));
        continue;
      }

      if (child.value && child.type !== 'open') {
        queue.push(append(queue.pop(), child.value));
        continue;
      }

      if (child.nodes) {
        walk(child, node);
      }
    }

    return queue;
  };

  return utils$5.flatten(walk(ast));
};

var expand_1 = expand$1;

var constants$3 = {
  MAX_LENGTH: 1024 * 64,

  // Digits
  CHAR_0: '0', /* 0 */
  CHAR_9: '9', /* 9 */

  // Alphabet chars.
  CHAR_UPPERCASE_A: 'A', /* A */
  CHAR_LOWERCASE_A: 'a', /* a */
  CHAR_UPPERCASE_Z: 'Z', /* Z */
  CHAR_LOWERCASE_Z: 'z', /* z */

  CHAR_LEFT_PARENTHESES: '(', /* ( */
  CHAR_RIGHT_PARENTHESES: ')', /* ) */

  CHAR_ASTERISK: '*', /* * */

  // Non-alphabetic chars.
  CHAR_AMPERSAND: '&', /* & */
  CHAR_AT: '@', /* @ */
  CHAR_BACKSLASH: '\\', /* \ */
  CHAR_BACKTICK: '`', /* ` */
  CHAR_CARRIAGE_RETURN: '\r', /* \r */
  CHAR_CIRCUMFLEX_ACCENT: '^', /* ^ */
  CHAR_COLON: ':', /* : */
  CHAR_COMMA: ',', /* , */
  CHAR_DOLLAR: '$', /* . */
  CHAR_DOT: '.', /* . */
  CHAR_DOUBLE_QUOTE: '"', /* " */
  CHAR_EQUAL: '=', /* = */
  CHAR_EXCLAMATION_MARK: '!', /* ! */
  CHAR_FORM_FEED: '\f', /* \f */
  CHAR_FORWARD_SLASH: '/', /* / */
  CHAR_HASH: '#', /* # */
  CHAR_HYPHEN_MINUS: '-', /* - */
  CHAR_LEFT_ANGLE_BRACKET: '<', /* < */
  CHAR_LEFT_CURLY_BRACE: '{', /* { */
  CHAR_LEFT_SQUARE_BRACKET: '[', /* [ */
  CHAR_LINE_FEED: '\n', /* \n */
  CHAR_NO_BREAK_SPACE: '\u00A0', /* \u00A0 */
  CHAR_PERCENT: '%', /* % */
  CHAR_PLUS: '+', /* + */
  CHAR_QUESTION_MARK: '?', /* ? */
  CHAR_RIGHT_ANGLE_BRACKET: '>', /* > */
  CHAR_RIGHT_CURLY_BRACE: '}', /* } */
  CHAR_RIGHT_SQUARE_BRACKET: ']', /* ] */
  CHAR_SEMICOLON: ';', /* ; */
  CHAR_SINGLE_QUOTE: '\'', /* ' */
  CHAR_SPACE: ' ', /*   */
  CHAR_TAB: '\t', /* \t */
  CHAR_UNDERSCORE: '_', /* _ */
  CHAR_VERTICAL_LINE: '|', /* | */
  CHAR_ZERO_WIDTH_NOBREAK_SPACE: '\uFEFF' /* \uFEFF */
};

const stringify$1 = stringify$4;

/**
 * Constants
 */

const {
  MAX_LENGTH: MAX_LENGTH$1,
  CHAR_BACKSLASH, /* \ */
  CHAR_BACKTICK, /* ` */
  CHAR_COMMA: CHAR_COMMA$1, /* , */
  CHAR_DOT: CHAR_DOT$1, /* . */
  CHAR_LEFT_PARENTHESES: CHAR_LEFT_PARENTHESES$1, /* ( */
  CHAR_RIGHT_PARENTHESES: CHAR_RIGHT_PARENTHESES$1, /* ) */
  CHAR_LEFT_CURLY_BRACE: CHAR_LEFT_CURLY_BRACE$1, /* { */
  CHAR_RIGHT_CURLY_BRACE: CHAR_RIGHT_CURLY_BRACE$1, /* } */
  CHAR_LEFT_SQUARE_BRACKET: CHAR_LEFT_SQUARE_BRACKET$1, /* [ */
  CHAR_RIGHT_SQUARE_BRACKET: CHAR_RIGHT_SQUARE_BRACKET$1, /* ] */
  CHAR_DOUBLE_QUOTE, /* " */
  CHAR_SINGLE_QUOTE, /* ' */
  CHAR_NO_BREAK_SPACE,
  CHAR_ZERO_WIDTH_NOBREAK_SPACE
} = constants$3;

/**
 * parse
 */

const parse$3 = (input, options = {}) => {
  if (typeof input !== 'string') {
    throw new TypeError('Expected a string');
  }

  let opts = options || {};
  let max = typeof opts.maxLength === 'number' ? Math.min(MAX_LENGTH$1, opts.maxLength) : MAX_LENGTH$1;
  if (input.length > max) {
    throw new SyntaxError(`Input length (${input.length}), exceeds max characters (${max})`);
  }

  let ast = { type: 'root', input, nodes: [] };
  let stack = [ast];
  let block = ast;
  let prev = ast;
  let brackets = 0;
  let length = input.length;
  let index = 0;
  let depth = 0;
  let value;

  /**
   * Helpers
   */

  const advance = () => input[index++];
  const push = node => {
    if (node.type === 'text' && prev.type === 'dot') {
      prev.type = 'text';
    }

    if (prev && prev.type === 'text' && node.type === 'text') {
      prev.value += node.value;
      return;
    }

    block.nodes.push(node);
    node.parent = block;
    node.prev = prev;
    prev = node;
    return node;
  };

  push({ type: 'bos' });

  while (index < length) {
    block = stack[stack.length - 1];
    value = advance();

    /**
     * Invalid chars
     */

    if (value === CHAR_ZERO_WIDTH_NOBREAK_SPACE || value === CHAR_NO_BREAK_SPACE) {
      continue;
    }

    /**
     * Escaped chars
     */

    if (value === CHAR_BACKSLASH) {
      push({ type: 'text', value: (options.keepEscaping ? value : '') + advance() });
      continue;
    }

    /**
     * Right square bracket (literal): ']'
     */

    if (value === CHAR_RIGHT_SQUARE_BRACKET$1) {
      push({ type: 'text', value: '\\' + value });
      continue;
    }

    /**
     * Left square bracket: '['
     */

    if (value === CHAR_LEFT_SQUARE_BRACKET$1) {
      brackets++;
      let next;

      while (index < length && (next = advance())) {
        value += next;

        if (next === CHAR_LEFT_SQUARE_BRACKET$1) {
          brackets++;
          continue;
        }

        if (next === CHAR_BACKSLASH) {
          value += advance();
          continue;
        }

        if (next === CHAR_RIGHT_SQUARE_BRACKET$1) {
          brackets--;

          if (brackets === 0) {
            break;
          }
        }
      }

      push({ type: 'text', value });
      continue;
    }

    /**
     * Parentheses
     */

    if (value === CHAR_LEFT_PARENTHESES$1) {
      block = push({ type: 'paren', nodes: [] });
      stack.push(block);
      push({ type: 'text', value });
      continue;
    }

    if (value === CHAR_RIGHT_PARENTHESES$1) {
      if (block.type !== 'paren') {
        push({ type: 'text', value });
        continue;
      }
      block = stack.pop();
      push({ type: 'text', value });
      block = stack[stack.length - 1];
      continue;
    }

    /**
     * Quotes: '|"|`
     */

    if (value === CHAR_DOUBLE_QUOTE || value === CHAR_SINGLE_QUOTE || value === CHAR_BACKTICK) {
      let open = value;
      let next;

      if (options.keepQuotes !== true) {
        value = '';
      }

      while (index < length && (next = advance())) {
        if (next === CHAR_BACKSLASH) {
          value += next + advance();
          continue;
        }

        if (next === open) {
          if (options.keepQuotes === true) value += next;
          break;
        }

        value += next;
      }

      push({ type: 'text', value });
      continue;
    }

    /**
     * Left curly brace: '{'
     */

    if (value === CHAR_LEFT_CURLY_BRACE$1) {
      depth++;

      let dollar = prev.value && prev.value.slice(-1) === '$' || block.dollar === true;
      let brace = {
        type: 'brace',
        open: true,
        close: false,
        dollar,
        depth,
        commas: 0,
        ranges: 0,
        nodes: []
      };

      block = push(brace);
      stack.push(block);
      push({ type: 'open', value });
      continue;
    }

    /**
     * Right curly brace: '}'
     */

    if (value === CHAR_RIGHT_CURLY_BRACE$1) {
      if (block.type !== 'brace') {
        push({ type: 'text', value });
        continue;
      }

      let type = 'close';
      block = stack.pop();
      block.close = true;

      push({ type, value });
      depth--;

      block = stack[stack.length - 1];
      continue;
    }

    /**
     * Comma: ','
     */

    if (value === CHAR_COMMA$1 && depth > 0) {
      if (block.ranges > 0) {
        block.ranges = 0;
        let open = block.nodes.shift();
        block.nodes = [open, { type: 'text', value: stringify$1(block) }];
      }

      push({ type: 'comma', value });
      block.commas++;
      continue;
    }

    /**
     * Dot: '.'
     */

    if (value === CHAR_DOT$1 && depth > 0 && block.commas === 0) {
      let siblings = block.nodes;

      if (depth === 0 || siblings.length === 0) {
        push({ type: 'text', value });
        continue;
      }

      if (prev.type === 'dot') {
        block.range = [];
        prev.value += value;
        prev.type = 'range';

        if (block.nodes.length !== 3 && block.nodes.length !== 5) {
          block.invalid = true;
          block.ranges = 0;
          prev.type = 'text';
          continue;
        }

        block.ranges++;
        block.args = [];
        continue;
      }

      if (prev.type === 'range') {
        siblings.pop();

        let before = siblings[siblings.length - 1];
        before.value += prev.value + value;
        prev = before;
        block.ranges--;
        continue;
      }

      push({ type: 'dot', value });
      continue;
    }

    /**
     * Text
     */

    push({ type: 'text', value });
  }

  // Mark imbalanced braces and brackets as invalid
  do {
    block = stack.pop();

    if (block.type !== 'root') {
      block.nodes.forEach(node => {
        if (!node.nodes) {
          if (node.type === 'open') node.isOpen = true;
          if (node.type === 'close') node.isClose = true;
          if (!node.nodes) node.type = 'text';
          node.invalid = true;
        }
      });

      // get the location of the block on parent.nodes (block's siblings)
      let parent = stack[stack.length - 1];
      let index = parent.nodes.indexOf(block);
      // replace the (invalid) block with it's nodes
      parent.nodes.splice(index, 1, ...block.nodes);
    }
  } while (stack.length > 0);

  push({ type: 'eos' });
  return ast;
};

var parse_1$1 = parse$3;

const stringify = stringify$4;
const compile = compile_1;
const expand = expand_1;
const parse$2 = parse_1$1;

/**
 * Expand the given pattern or create a regex-compatible string.
 *
 * ```js
 * const braces = require('braces');
 * console.log(braces('{a,b,c}', { compile: true })); //=> ['(a|b|c)']
 * console.log(braces('{a,b,c}')); //=> ['a', 'b', 'c']
 * ```
 * @param {String} `str`
 * @param {Object} `options`
 * @return {String}
 * @api public
 */

const braces$1 = (input, options = {}) => {
  let output = [];

  if (Array.isArray(input)) {
    for (let pattern of input) {
      let result = braces$1.create(pattern, options);
      if (Array.isArray(result)) {
        output.push(...result);
      } else {
        output.push(result);
      }
    }
  } else {
    output = [].concat(braces$1.create(input, options));
  }

  if (options && options.expand === true && options.nodupes === true) {
    output = [...new Set(output)];
  }
  return output;
};

/**
 * Parse the given `str` with the given `options`.
 *
 * ```js
 * // braces.parse(pattern, [, options]);
 * const ast = braces.parse('a/{b,c}/d');
 * console.log(ast);
 * ```
 * @param {String} pattern Brace pattern to parse
 * @param {Object} options
 * @return {Object} Returns an AST
 * @api public
 */

braces$1.parse = (input, options = {}) => parse$2(input, options);

/**
 * Creates a braces string from an AST, or an AST node.
 *
 * ```js
 * const braces = require('braces');
 * let ast = braces.parse('foo/{a,b}/bar');
 * console.log(stringify(ast.nodes[2])); //=> '{a,b}'
 * ```
 * @param {String} `input` Brace pattern or AST.
 * @param {Object} `options`
 * @return {Array} Returns an array of expanded values.
 * @api public
 */

braces$1.stringify = (input, options = {}) => {
  if (typeof input === 'string') {
    return stringify(braces$1.parse(input, options), options);
  }
  return stringify(input, options);
};

/**
 * Compiles a brace pattern into a regex-compatible, optimized string.
 * This method is called by the main [braces](#braces) function by default.
 *
 * ```js
 * const braces = require('braces');
 * console.log(braces.compile('a/{b,c}/d'));
 * //=> ['a/(b|c)/d']
 * ```
 * @param {String} `input` Brace pattern or AST.
 * @param {Object} `options`
 * @return {Array} Returns an array of expanded values.
 * @api public
 */

braces$1.compile = (input, options = {}) => {
  if (typeof input === 'string') {
    input = braces$1.parse(input, options);
  }
  return compile(input, options);
};

/**
 * Expands a brace pattern into an array. This method is called by the
 * main [braces](#braces) function when `options.expand` is true. Before
 * using this method it's recommended that you read the [performance notes](#performance))
 * and advantages of using [.compile](#compile) instead.
 *
 * ```js
 * const braces = require('braces');
 * console.log(braces.expand('a/{b,c}/d'));
 * //=> ['a/b/d', 'a/c/d'];
 * ```
 * @param {String} `pattern` Brace pattern
 * @param {Object} `options`
 * @return {Array} Returns an array of expanded values.
 * @api public
 */

braces$1.expand = (input, options = {}) => {
  if (typeof input === 'string') {
    input = braces$1.parse(input, options);
  }

  let result = expand(input, options);

  // filter out empty strings if specified
  if (options.noempty === true) {
    result = result.filter(Boolean);
  }

  // filter out duplicates if specified
  if (options.nodupes === true) {
    result = [...new Set(result)];
  }

  return result;
};

/**
 * Processes a brace pattern and returns either an expanded array
 * (if `options.expand` is true), a highly optimized regex-compatible string.
 * This method is called by the main [braces](#braces) function.
 *
 * ```js
 * const braces = require('braces');
 * console.log(braces.create('user-{200..300}/project-{a,b,c}-{1..10}'))
 * //=> 'user-(20[0-9]|2[1-9][0-9]|300)/project-(a|b|c)-([1-9]|10)'
 * ```
 * @param {String} `pattern` Brace pattern
 * @param {Object} `options`
 * @return {Array} Returns an array of expanded values.
 * @api public
 */

braces$1.create = (input, options = {}) => {
  if (input === '' || input.length < 3) {
    return [input];
  }

 return options.expand !== true
    ? braces$1.compile(input, options)
    : braces$1.expand(input, options);
};

/**
 * Expose "braces"
 */

var braces_1 = braces$1;

var picomatch$2 = {exports: {}};

var path$2 = { sep: '/' };

var utils$4 = {};

const path$1 = path$2;
const WIN_SLASH = '\\\\/';
const WIN_NO_SLASH = `[^${WIN_SLASH}]`;

/**
 * Posix glob regex
 */

const DOT_LITERAL = '\\.';
const PLUS_LITERAL = '\\+';
const QMARK_LITERAL = '\\?';
const SLASH_LITERAL = '\\/';
const ONE_CHAR = '(?=.)';
const QMARK = '[^/]';
const END_ANCHOR = `(?:${SLASH_LITERAL}|$)`;
const START_ANCHOR = `(?:^|${SLASH_LITERAL})`;
const DOTS_SLASH = `${DOT_LITERAL}{1,2}${END_ANCHOR}`;
const NO_DOT = `(?!${DOT_LITERAL})`;
const NO_DOTS = `(?!${START_ANCHOR}${DOTS_SLASH})`;
const NO_DOT_SLASH = `(?!${DOT_LITERAL}{0,1}${END_ANCHOR})`;
const NO_DOTS_SLASH = `(?!${DOTS_SLASH})`;
const QMARK_NO_DOT = `[^.${SLASH_LITERAL}]`;
const STAR = `${QMARK}*?`;

const POSIX_CHARS = {
  DOT_LITERAL,
  PLUS_LITERAL,
  QMARK_LITERAL,
  SLASH_LITERAL,
  ONE_CHAR,
  QMARK,
  END_ANCHOR,
  DOTS_SLASH,
  NO_DOT,
  NO_DOTS,
  NO_DOT_SLASH,
  NO_DOTS_SLASH,
  QMARK_NO_DOT,
  STAR,
  START_ANCHOR
};

/**
 * Windows glob regex
 */

const WINDOWS_CHARS = {
  ...POSIX_CHARS,

  SLASH_LITERAL: `[${WIN_SLASH}]`,
  QMARK: WIN_NO_SLASH,
  STAR: `${WIN_NO_SLASH}*?`,
  DOTS_SLASH: `${DOT_LITERAL}{1,2}(?:[${WIN_SLASH}]|$)`,
  NO_DOT: `(?!${DOT_LITERAL})`,
  NO_DOTS: `(?!(?:^|[${WIN_SLASH}])${DOT_LITERAL}{1,2}(?:[${WIN_SLASH}]|$))`,
  NO_DOT_SLASH: `(?!${DOT_LITERAL}{0,1}(?:[${WIN_SLASH}]|$))`,
  NO_DOTS_SLASH: `(?!${DOT_LITERAL}{1,2}(?:[${WIN_SLASH}]|$))`,
  QMARK_NO_DOT: `[^.${WIN_SLASH}]`,
  START_ANCHOR: `(?:^|[${WIN_SLASH}])`,
  END_ANCHOR: `(?:[${WIN_SLASH}]|$)`
};

/**
 * POSIX Bracket Regex
 */

const POSIX_REGEX_SOURCE$1 = {
  alnum: 'a-zA-Z0-9',
  alpha: 'a-zA-Z',
  ascii: '\\x00-\\x7F',
  blank: ' \\t',
  cntrl: '\\x00-\\x1F\\x7F',
  digit: '0-9',
  graph: '\\x21-\\x7E',
  lower: 'a-z',
  print: '\\x20-\\x7E ',
  punct: '\\-!"#$%&\'()\\*+,./:;<=>?@[\\]^_`{|}~',
  space: ' \\t\\r\\n\\v\\f',
  upper: 'A-Z',
  word: 'A-Za-z0-9_',
  xdigit: 'A-Fa-f0-9'
};

var constants$2 = {
  MAX_LENGTH: 1024 * 64,
  POSIX_REGEX_SOURCE: POSIX_REGEX_SOURCE$1,

  // regular expressions
  REGEX_BACKSLASH: /\\(?![*+?^${}(|)[\]])/g,
  REGEX_NON_SPECIAL_CHARS: /^[^@![\].,$*+?^{}()|\\/]+/,
  REGEX_SPECIAL_CHARS: /[-*+?.^${}(|)[\]]/,
  REGEX_SPECIAL_CHARS_BACKREF: /(\\?)((\W)(\3*))/g,
  REGEX_SPECIAL_CHARS_GLOBAL: /([-*+?.^${}(|)[\]])/g,
  REGEX_REMOVE_BACKSLASH: /(?:\[.*?[^\\]\]|\\(?=.))/g,

  // Replace globs with equivalent patterns to reduce parsing time.
  REPLACEMENTS: {
    '***': '*',
    '**/**': '**',
    '**/**/**': '**'
  },

  // Digits
  CHAR_0: 48, /* 0 */
  CHAR_9: 57, /* 9 */

  // Alphabet chars.
  CHAR_UPPERCASE_A: 65, /* A */
  CHAR_LOWERCASE_A: 97, /* a */
  CHAR_UPPERCASE_Z: 90, /* Z */
  CHAR_LOWERCASE_Z: 122, /* z */

  CHAR_LEFT_PARENTHESES: 40, /* ( */
  CHAR_RIGHT_PARENTHESES: 41, /* ) */

  CHAR_ASTERISK: 42, /* * */

  // Non-alphabetic chars.
  CHAR_AMPERSAND: 38, /* & */
  CHAR_AT: 64, /* @ */
  CHAR_BACKWARD_SLASH: 92, /* \ */
  CHAR_CARRIAGE_RETURN: 13, /* \r */
  CHAR_CIRCUMFLEX_ACCENT: 94, /* ^ */
  CHAR_COLON: 58, /* : */
  CHAR_COMMA: 44, /* , */
  CHAR_DOT: 46, /* . */
  CHAR_DOUBLE_QUOTE: 34, /* " */
  CHAR_EQUAL: 61, /* = */
  CHAR_EXCLAMATION_MARK: 33, /* ! */
  CHAR_FORM_FEED: 12, /* \f */
  CHAR_FORWARD_SLASH: 47, /* / */
  CHAR_GRAVE_ACCENT: 96, /* ` */
  CHAR_HASH: 35, /* # */
  CHAR_HYPHEN_MINUS: 45, /* - */
  CHAR_LEFT_ANGLE_BRACKET: 60, /* < */
  CHAR_LEFT_CURLY_BRACE: 123, /* { */
  CHAR_LEFT_SQUARE_BRACKET: 91, /* [ */
  CHAR_LINE_FEED: 10, /* \n */
  CHAR_NO_BREAK_SPACE: 160, /* \u00A0 */
  CHAR_PERCENT: 37, /* % */
  CHAR_PLUS: 43, /* + */
  CHAR_QUESTION_MARK: 63, /* ? */
  CHAR_RIGHT_ANGLE_BRACKET: 62, /* > */
  CHAR_RIGHT_CURLY_BRACE: 125, /* } */
  CHAR_RIGHT_SQUARE_BRACKET: 93, /* ] */
  CHAR_SEMICOLON: 59, /* ; */
  CHAR_SINGLE_QUOTE: 39, /* ' */
  CHAR_SPACE: 32, /*   */
  CHAR_TAB: 9, /* \t */
  CHAR_UNDERSCORE: 95, /* _ */
  CHAR_VERTICAL_LINE: 124, /* | */
  CHAR_ZERO_WIDTH_NOBREAK_SPACE: 65279, /* \uFEFF */

  SEP: path$1.sep,

  /**
   * Create EXTGLOB_CHARS
   */

  extglobChars(chars) {
    return {
      '!': { type: 'negate', open: '(?:(?!(?:', close: `))${chars.STAR})` },
      '?': { type: 'qmark', open: '(?:', close: ')?' },
      '+': { type: 'plus', open: '(?:', close: ')+' },
      '*': { type: 'star', open: '(?:', close: ')*' },
      '@': { type: 'at', open: '(?:', close: ')' }
    };
  },

  /**
   * Create GLOB_CHARS
   */

  globChars(win32) {
    return win32 === true ? WINDOWS_CHARS : POSIX_CHARS;
  }
};

(function (exports) {

	const path = path$2;
	const {
	  REGEX_BACKSLASH,
	  REGEX_REMOVE_BACKSLASH,
	  REGEX_SPECIAL_CHARS,
	  REGEX_SPECIAL_CHARS_GLOBAL
	} = constants$2;

	exports.isObject = val => val !== null && typeof val === 'object' && !Array.isArray(val);
	exports.hasRegexChars = str => REGEX_SPECIAL_CHARS.test(str);
	exports.isRegexChar = str => str.length === 1 && exports.hasRegexChars(str);
	exports.escapeRegex = str => str.replace(REGEX_SPECIAL_CHARS_GLOBAL, '\\$1');
	exports.toPosixSlashes = str => str.replace(REGEX_BACKSLASH, '/');

	exports.removeBackslashes = str => {
	  return str.replace(REGEX_REMOVE_BACKSLASH, match => {
	    return match === '\\' ? '' : match;
	  });
	};

	exports.supportsLookbehinds = () => {
	  const segs = process.version.slice(1).split('.').map(Number);
	  if (segs.length === 3 && segs[0] >= 9 || (segs[0] === 8 && segs[1] >= 10)) {
	    return true;
	  }
	  return false;
	};

	exports.isWindows = options => {
	  if (options && typeof options.windows === 'boolean') {
	    return options.windows;
	  }
	  return path.sep === '\\';
	};

	exports.escapeLast = (input, char, lastIdx) => {
	  const idx = input.lastIndexOf(char, lastIdx);
	  if (idx === -1) return input;
	  if (input[idx - 1] === '\\') return exports.escapeLast(input, char, idx - 1);
	  return `${input.slice(0, idx)}\\${input.slice(idx)}`;
	};

	exports.removePrefix = (input, state = {}) => {
	  let output = input;
	  if (output.startsWith('./')) {
	    output = output.slice(2);
	    state.prefix = './';
	  }
	  return output;
	};

	exports.wrapOutput = (input, state = {}, options = {}) => {
	  const prepend = options.contains ? '' : '^';
	  const append = options.contains ? '' : '$';

	  let output = `${prepend}(?:${input})${append}`;
	  if (state.negated === true) {
	    output = `(?:^(?!${output}).*$)`;
	  }
	  return output;
	};
} (utils$4));

const utils$3 = utils$4;
const {
  CHAR_ASTERISK,             /* * */
  CHAR_AT,                   /* @ */
  CHAR_BACKWARD_SLASH,       /* \ */
  CHAR_COMMA,                /* , */
  CHAR_DOT,                  /* . */
  CHAR_EXCLAMATION_MARK,     /* ! */
  CHAR_FORWARD_SLASH,        /* / */
  CHAR_LEFT_CURLY_BRACE,     /* { */
  CHAR_LEFT_PARENTHESES,     /* ( */
  CHAR_LEFT_SQUARE_BRACKET,  /* [ */
  CHAR_PLUS,                 /* + */
  CHAR_QUESTION_MARK,        /* ? */
  CHAR_RIGHT_CURLY_BRACE,    /* } */
  CHAR_RIGHT_PARENTHESES,    /* ) */
  CHAR_RIGHT_SQUARE_BRACKET  /* ] */
} = constants$2;

const isPathSeparator = code => {
  return code === CHAR_FORWARD_SLASH || code === CHAR_BACKWARD_SLASH;
};

const depth = token => {
  if (token.isPrefix !== true) {
    token.depth = token.isGlobstar ? Infinity : 1;
  }
};

/**
 * Quickly scans a glob pattern and returns an object with a handful of
 * useful properties, like `isGlob`, `path` (the leading non-glob, if it exists),
 * `glob` (the actual pattern), `negated` (true if the path starts with `!` but not
 * with `!(`) and `negatedExtglob` (true if the path starts with `!(`).
 *
 * ```js
 * const pm = require('picomatch');
 * console.log(pm.scan('foo/bar/*.js'));
 * { isGlob: true, input: 'foo/bar/*.js', base: 'foo/bar', glob: '*.js' }
 * ```
 * @param {String} `str`
 * @param {Object} `options`
 * @return {Object} Returns an object with tokens and regex source string.
 * @api public
 */

const scan$1 = (input, options) => {
  const opts = options || {};

  const length = input.length - 1;
  const scanToEnd = opts.parts === true || opts.scanToEnd === true;
  const slashes = [];
  const tokens = [];
  const parts = [];

  let str = input;
  let index = -1;
  let start = 0;
  let lastIndex = 0;
  let isBrace = false;
  let isBracket = false;
  let isGlob = false;
  let isExtglob = false;
  let isGlobstar = false;
  let braceEscaped = false;
  let backslashes = false;
  let negated = false;
  let negatedExtglob = false;
  let finished = false;
  let braces = 0;
  let prev;
  let code;
  let token = { value: '', depth: 0, isGlob: false };

  const eos = () => index >= length;
  const peek = () => str.charCodeAt(index + 1);
  const advance = () => {
    prev = code;
    return str.charCodeAt(++index);
  };

  while (index < length) {
    code = advance();
    let next;

    if (code === CHAR_BACKWARD_SLASH) {
      backslashes = token.backslashes = true;
      code = advance();

      if (code === CHAR_LEFT_CURLY_BRACE) {
        braceEscaped = true;
      }
      continue;
    }

    if (braceEscaped === true || code === CHAR_LEFT_CURLY_BRACE) {
      braces++;

      while (eos() !== true && (code = advance())) {
        if (code === CHAR_BACKWARD_SLASH) {
          backslashes = token.backslashes = true;
          advance();
          continue;
        }

        if (code === CHAR_LEFT_CURLY_BRACE) {
          braces++;
          continue;
        }

        if (braceEscaped !== true && code === CHAR_DOT && (code = advance()) === CHAR_DOT) {
          isBrace = token.isBrace = true;
          isGlob = token.isGlob = true;
          finished = true;

          if (scanToEnd === true) {
            continue;
          }

          break;
        }

        if (braceEscaped !== true && code === CHAR_COMMA) {
          isBrace = token.isBrace = true;
          isGlob = token.isGlob = true;
          finished = true;

          if (scanToEnd === true) {
            continue;
          }

          break;
        }

        if (code === CHAR_RIGHT_CURLY_BRACE) {
          braces--;

          if (braces === 0) {
            braceEscaped = false;
            isBrace = token.isBrace = true;
            finished = true;
            break;
          }
        }
      }

      if (scanToEnd === true) {
        continue;
      }

      break;
    }

    if (code === CHAR_FORWARD_SLASH) {
      slashes.push(index);
      tokens.push(token);
      token = { value: '', depth: 0, isGlob: false };

      if (finished === true) continue;
      if (prev === CHAR_DOT && index === (start + 1)) {
        start += 2;
        continue;
      }

      lastIndex = index + 1;
      continue;
    }

    if (opts.noext !== true) {
      const isExtglobChar = code === CHAR_PLUS
        || code === CHAR_AT
        || code === CHAR_ASTERISK
        || code === CHAR_QUESTION_MARK
        || code === CHAR_EXCLAMATION_MARK;

      if (isExtglobChar === true && peek() === CHAR_LEFT_PARENTHESES) {
        isGlob = token.isGlob = true;
        isExtglob = token.isExtglob = true;
        finished = true;
        if (code === CHAR_EXCLAMATION_MARK && index === start) {
          negatedExtglob = true;
        }

        if (scanToEnd === true) {
          while (eos() !== true && (code = advance())) {
            if (code === CHAR_BACKWARD_SLASH) {
              backslashes = token.backslashes = true;
              code = advance();
              continue;
            }

            if (code === CHAR_RIGHT_PARENTHESES) {
              isGlob = token.isGlob = true;
              finished = true;
              break;
            }
          }
          continue;
        }
        break;
      }
    }

    if (code === CHAR_ASTERISK) {
      if (prev === CHAR_ASTERISK) isGlobstar = token.isGlobstar = true;
      isGlob = token.isGlob = true;
      finished = true;

      if (scanToEnd === true) {
        continue;
      }
      break;
    }

    if (code === CHAR_QUESTION_MARK) {
      isGlob = token.isGlob = true;
      finished = true;

      if (scanToEnd === true) {
        continue;
      }
      break;
    }

    if (code === CHAR_LEFT_SQUARE_BRACKET) {
      while (eos() !== true && (next = advance())) {
        if (next === CHAR_BACKWARD_SLASH) {
          backslashes = token.backslashes = true;
          advance();
          continue;
        }

        if (next === CHAR_RIGHT_SQUARE_BRACKET) {
          isBracket = token.isBracket = true;
          isGlob = token.isGlob = true;
          finished = true;
          break;
        }
      }

      if (scanToEnd === true) {
        continue;
      }

      break;
    }

    if (opts.nonegate !== true && code === CHAR_EXCLAMATION_MARK && index === start) {
      negated = token.negated = true;
      start++;
      continue;
    }

    if (opts.noparen !== true && code === CHAR_LEFT_PARENTHESES) {
      isGlob = token.isGlob = true;

      if (scanToEnd === true) {
        while (eos() !== true && (code = advance())) {
          if (code === CHAR_LEFT_PARENTHESES) {
            backslashes = token.backslashes = true;
            code = advance();
            continue;
          }

          if (code === CHAR_RIGHT_PARENTHESES) {
            finished = true;
            break;
          }
        }
        continue;
      }
      break;
    }

    if (isGlob === true) {
      finished = true;

      if (scanToEnd === true) {
        continue;
      }

      break;
    }
  }

  if (opts.noext === true) {
    isExtglob = false;
    isGlob = false;
  }

  let base = str;
  let prefix = '';
  let glob = '';

  if (start > 0) {
    prefix = str.slice(0, start);
    str = str.slice(start);
    lastIndex -= start;
  }

  if (base && isGlob === true && lastIndex > 0) {
    base = str.slice(0, lastIndex);
    glob = str.slice(lastIndex);
  } else if (isGlob === true) {
    base = '';
    glob = str;
  } else {
    base = str;
  }

  if (base && base !== '' && base !== '/' && base !== str) {
    if (isPathSeparator(base.charCodeAt(base.length - 1))) {
      base = base.slice(0, -1);
    }
  }

  if (opts.unescape === true) {
    if (glob) glob = utils$3.removeBackslashes(glob);

    if (base && backslashes === true) {
      base = utils$3.removeBackslashes(base);
    }
  }

  const state = {
    prefix,
    input,
    start,
    base,
    glob,
    isBrace,
    isBracket,
    isGlob,
    isExtglob,
    isGlobstar,
    negated,
    negatedExtglob
  };

  if (opts.tokens === true) {
    state.maxDepth = 0;
    if (!isPathSeparator(code)) {
      tokens.push(token);
    }
    state.tokens = tokens;
  }

  if (opts.parts === true || opts.tokens === true) {
    let prevIndex;

    for (let idx = 0; idx < slashes.length; idx++) {
      const n = prevIndex ? prevIndex + 1 : start;
      const i = slashes[idx];
      const value = input.slice(n, i);
      if (opts.tokens) {
        if (idx === 0 && start !== 0) {
          tokens[idx].isPrefix = true;
          tokens[idx].value = prefix;
        } else {
          tokens[idx].value = value;
        }
        depth(tokens[idx]);
        state.maxDepth += tokens[idx].depth;
      }
      if (idx !== 0 || value !== '') {
        parts.push(value);
      }
      prevIndex = i;
    }

    if (prevIndex && prevIndex + 1 < input.length) {
      const value = input.slice(prevIndex + 1);
      parts.push(value);

      if (opts.tokens) {
        tokens[tokens.length - 1].value = value;
        depth(tokens[tokens.length - 1]);
        state.maxDepth += tokens[tokens.length - 1].depth;
      }
    }

    state.slashes = slashes;
    state.parts = parts;
  }

  return state;
};

var scan_1 = scan$1;

const constants$1 = constants$2;
const utils$2 = utils$4;

/**
 * Constants
 */

const {
  MAX_LENGTH,
  POSIX_REGEX_SOURCE,
  REGEX_NON_SPECIAL_CHARS,
  REGEX_SPECIAL_CHARS_BACKREF,
  REPLACEMENTS
} = constants$1;

/**
 * Helpers
 */

const expandRange = (args, options) => {
  if (typeof options.expandRange === 'function') {
    return options.expandRange(...args, options);
  }

  args.sort();
  const value = `[${args.join('-')}]`;

  try {
    /* eslint-disable-next-line no-new */
    new RegExp(value);
  } catch (ex) {
    return args.map(v => utils$2.escapeRegex(v)).join('..');
  }

  return value;
};

/**
 * Create the message for a syntax error
 */

const syntaxError = (type, char) => {
  return `Missing ${type}: "${char}" - use "\\\\${char}" to match literal characters`;
};

/**
 * Parse the given input string.
 * @param {String} input
 * @param {Object} options
 * @return {Object}
 */

const parse$1 = (input, options) => {
  if (typeof input !== 'string') {
    throw new TypeError('Expected a string');
  }

  input = REPLACEMENTS[input] || input;

  const opts = { ...options };
  const max = typeof opts.maxLength === 'number' ? Math.min(MAX_LENGTH, opts.maxLength) : MAX_LENGTH;

  let len = input.length;
  if (len > max) {
    throw new SyntaxError(`Input length: ${len}, exceeds maximum allowed length: ${max}`);
  }

  const bos = { type: 'bos', value: '', output: opts.prepend || '' };
  const tokens = [bos];

  const capture = opts.capture ? '' : '?:';
  const win32 = utils$2.isWindows(options);

  // create constants based on platform, for windows or posix
  const PLATFORM_CHARS = constants$1.globChars(win32);
  const EXTGLOB_CHARS = constants$1.extglobChars(PLATFORM_CHARS);

  const {
    DOT_LITERAL,
    PLUS_LITERAL,
    SLASH_LITERAL,
    ONE_CHAR,
    DOTS_SLASH,
    NO_DOT,
    NO_DOT_SLASH,
    NO_DOTS_SLASH,
    QMARK,
    QMARK_NO_DOT,
    STAR,
    START_ANCHOR
  } = PLATFORM_CHARS;

  const globstar = opts => {
    return `(${capture}(?:(?!${START_ANCHOR}${opts.dot ? DOTS_SLASH : DOT_LITERAL}).)*?)`;
  };

  const nodot = opts.dot ? '' : NO_DOT;
  const qmarkNoDot = opts.dot ? QMARK : QMARK_NO_DOT;
  let star = opts.bash === true ? globstar(opts) : STAR;

  if (opts.capture) {
    star = `(${star})`;
  }

  // minimatch options support
  if (typeof opts.noext === 'boolean') {
    opts.noextglob = opts.noext;
  }

  const state = {
    input,
    index: -1,
    start: 0,
    dot: opts.dot === true,
    consumed: '',
    output: '',
    prefix: '',
    backtrack: false,
    negated: false,
    brackets: 0,
    braces: 0,
    parens: 0,
    quotes: 0,
    globstar: false,
    tokens
  };

  input = utils$2.removePrefix(input, state);
  len = input.length;

  const extglobs = [];
  const braces = [];
  const stack = [];
  let prev = bos;
  let value;

  /**
   * Tokenizing helpers
   */

  const eos = () => state.index === len - 1;
  const peek = state.peek = (n = 1) => input[state.index + n];
  const advance = state.advance = () => input[++state.index] || '';
  const remaining = () => input.slice(state.index + 1);
  const consume = (value = '', num = 0) => {
    state.consumed += value;
    state.index += num;
  };

  const append = token => {
    state.output += token.output != null ? token.output : token.value;
    consume(token.value);
  };

  const negate = () => {
    let count = 1;

    while (peek() === '!' && (peek(2) !== '(' || peek(3) === '?')) {
      advance();
      state.start++;
      count++;
    }

    if (count % 2 === 0) {
      return false;
    }

    state.negated = true;
    state.start++;
    return true;
  };

  const increment = type => {
    state[type]++;
    stack.push(type);
  };

  const decrement = type => {
    state[type]--;
    stack.pop();
  };

  /**
   * Push tokens onto the tokens array. This helper speeds up
   * tokenizing by 1) helping us avoid backtracking as much as possible,
   * and 2) helping us avoid creating extra tokens when consecutive
   * characters are plain text. This improves performance and simplifies
   * lookbehinds.
   */

  const push = tok => {
    if (prev.type === 'globstar') {
      const isBrace = state.braces > 0 && (tok.type === 'comma' || tok.type === 'brace');
      const isExtglob = tok.extglob === true || (extglobs.length && (tok.type === 'pipe' || tok.type === 'paren'));

      if (tok.type !== 'slash' && tok.type !== 'paren' && !isBrace && !isExtglob) {
        state.output = state.output.slice(0, -prev.output.length);
        prev.type = 'star';
        prev.value = '*';
        prev.output = star;
        state.output += prev.output;
      }
    }

    if (extglobs.length && tok.type !== 'paren') {
      extglobs[extglobs.length - 1].inner += tok.value;
    }

    if (tok.value || tok.output) append(tok);
    if (prev && prev.type === 'text' && tok.type === 'text') {
      prev.value += tok.value;
      prev.output = (prev.output || '') + tok.value;
      return;
    }

    tok.prev = prev;
    tokens.push(tok);
    prev = tok;
  };

  const extglobOpen = (type, value) => {
    const token = { ...EXTGLOB_CHARS[value], conditions: 1, inner: '' };

    token.prev = prev;
    token.parens = state.parens;
    token.output = state.output;
    const output = (opts.capture ? '(' : '') + token.open;

    increment('parens');
    push({ type, value, output: state.output ? '' : ONE_CHAR });
    push({ type: 'paren', extglob: true, value: advance(), output });
    extglobs.push(token);
  };

  const extglobClose = token => {
    let output = token.close + (opts.capture ? ')' : '');
    let rest;

    if (token.type === 'negate') {
      let extglobStar = star;

      if (token.inner && token.inner.length > 1 && token.inner.includes('/')) {
        extglobStar = globstar(opts);
      }

      if (extglobStar !== star || eos() || /^\)+$/.test(remaining())) {
        output = token.close = `)$))${extglobStar}`;
      }

      if (token.inner.includes('*') && (rest = remaining()) && /^\.[^\\/.]+$/.test(rest)) {
        // Any non-magical string (`.ts`) or even nested expression (`.{ts,tsx}`) can follow after the closing parenthesis.
        // In this case, we need to parse the string and use it in the output of the original pattern.
        // Suitable patterns: `/!(*.d).ts`, `/!(*.d).{ts,tsx}`, `**/!(*-dbg).@(js)`.
        //
        // Disabling the `fastpaths` option due to a problem with parsing strings as `.ts` in the pattern like `**/!(*.d).ts`.
        const expression = parse$1(rest, { ...options, fastpaths: false }).output;

        output = token.close = `)${expression})${extglobStar})`;
      }

      if (token.prev.type === 'bos') {
        state.negatedExtglob = true;
      }
    }

    push({ type: 'paren', extglob: true, value, output });
    decrement('parens');
  };

  /**
   * Fast paths
   */

  if (opts.fastpaths !== false && !/(^[*!]|[/()[\]{}"])/.test(input)) {
    let backslashes = false;

    let output = input.replace(REGEX_SPECIAL_CHARS_BACKREF, (m, esc, chars, first, rest, index) => {
      if (first === '\\') {
        backslashes = true;
        return m;
      }

      if (first === '?') {
        if (esc) {
          return esc + first + (rest ? QMARK.repeat(rest.length) : '');
        }
        if (index === 0) {
          return qmarkNoDot + (rest ? QMARK.repeat(rest.length) : '');
        }
        return QMARK.repeat(chars.length);
      }

      if (first === '.') {
        return DOT_LITERAL.repeat(chars.length);
      }

      if (first === '*') {
        if (esc) {
          return esc + first + (rest ? star : '');
        }
        return star;
      }
      return esc ? m : `\\${m}`;
    });

    if (backslashes === true) {
      if (opts.unescape === true) {
        output = output.replace(/\\/g, '');
      } else {
        output = output.replace(/\\+/g, m => {
          return m.length % 2 === 0 ? '\\\\' : (m ? '\\' : '');
        });
      }
    }

    if (output === input && opts.contains === true) {
      state.output = input;
      return state;
    }

    state.output = utils$2.wrapOutput(output, state, options);
    return state;
  }

  /**
   * Tokenize input until we reach end-of-string
   */

  while (!eos()) {
    value = advance();

    if (value === '\u0000') {
      continue;
    }

    /**
     * Escaped characters
     */

    if (value === '\\') {
      const next = peek();

      if (next === '/' && opts.bash !== true) {
        continue;
      }

      if (next === '.' || next === ';') {
        continue;
      }

      if (!next) {
        value += '\\';
        push({ type: 'text', value });
        continue;
      }

      // collapse slashes to reduce potential for exploits
      const match = /^\\+/.exec(remaining());
      let slashes = 0;

      if (match && match[0].length > 2) {
        slashes = match[0].length;
        state.index += slashes;
        if (slashes % 2 !== 0) {
          value += '\\';
        }
      }

      if (opts.unescape === true) {
        value = advance();
      } else {
        value += advance();
      }

      if (state.brackets === 0) {
        push({ type: 'text', value });
        continue;
      }
    }

    /**
     * If we're inside a regex character class, continue
     * until we reach the closing bracket.
     */

    if (state.brackets > 0 && (value !== ']' || prev.value === '[' || prev.value === '[^')) {
      if (opts.posix !== false && value === ':') {
        const inner = prev.value.slice(1);
        if (inner.includes('[')) {
          prev.posix = true;

          if (inner.includes(':')) {
            const idx = prev.value.lastIndexOf('[');
            const pre = prev.value.slice(0, idx);
            const rest = prev.value.slice(idx + 2);
            const posix = POSIX_REGEX_SOURCE[rest];
            if (posix) {
              prev.value = pre + posix;
              state.backtrack = true;
              advance();

              if (!bos.output && tokens.indexOf(prev) === 1) {
                bos.output = ONE_CHAR;
              }
              continue;
            }
          }
        }
      }

      if ((value === '[' && peek() !== ':') || (value === '-' && peek() === ']')) {
        value = `\\${value}`;
      }

      if (value === ']' && (prev.value === '[' || prev.value === '[^')) {
        value = `\\${value}`;
      }

      if (opts.posix === true && value === '!' && prev.value === '[') {
        value = '^';
      }

      prev.value += value;
      append({ value });
      continue;
    }

    /**
     * If we're inside a quoted string, continue
     * until we reach the closing double quote.
     */

    if (state.quotes === 1 && value !== '"') {
      value = utils$2.escapeRegex(value);
      prev.value += value;
      append({ value });
      continue;
    }

    /**
     * Double quotes
     */

    if (value === '"') {
      state.quotes = state.quotes === 1 ? 0 : 1;
      if (opts.keepQuotes === true) {
        push({ type: 'text', value });
      }
      continue;
    }

    /**
     * Parentheses
     */

    if (value === '(') {
      increment('parens');
      push({ type: 'paren', value });
      continue;
    }

    if (value === ')') {
      if (state.parens === 0 && opts.strictBrackets === true) {
        throw new SyntaxError(syntaxError('opening', '('));
      }

      const extglob = extglobs[extglobs.length - 1];
      if (extglob && state.parens === extglob.parens + 1) {
        extglobClose(extglobs.pop());
        continue;
      }

      push({ type: 'paren', value, output: state.parens ? ')' : '\\)' });
      decrement('parens');
      continue;
    }

    /**
     * Square brackets
     */

    if (value === '[') {
      if (opts.nobracket === true || !remaining().includes(']')) {
        if (opts.nobracket !== true && opts.strictBrackets === true) {
          throw new SyntaxError(syntaxError('closing', ']'));
        }

        value = `\\${value}`;
      } else {
        increment('brackets');
      }

      push({ type: 'bracket', value });
      continue;
    }

    if (value === ']') {
      if (opts.nobracket === true || (prev && prev.type === 'bracket' && prev.value.length === 1)) {
        push({ type: 'text', value, output: `\\${value}` });
        continue;
      }

      if (state.brackets === 0) {
        if (opts.strictBrackets === true) {
          throw new SyntaxError(syntaxError('opening', '['));
        }

        push({ type: 'text', value, output: `\\${value}` });
        continue;
      }

      decrement('brackets');

      const prevValue = prev.value.slice(1);
      if (prev.posix !== true && prevValue[0] === '^' && !prevValue.includes('/')) {
        value = `/${value}`;
      }

      prev.value += value;
      append({ value });

      // when literal brackets are explicitly disabled
      // assume we should match with a regex character class
      if (opts.literalBrackets === false || utils$2.hasRegexChars(prevValue)) {
        continue;
      }

      const escaped = utils$2.escapeRegex(prev.value);
      state.output = state.output.slice(0, -prev.value.length);

      // when literal brackets are explicitly enabled
      // assume we should escape the brackets to match literal characters
      if (opts.literalBrackets === true) {
        state.output += escaped;
        prev.value = escaped;
        continue;
      }

      // when the user specifies nothing, try to match both
      prev.value = `(${capture}${escaped}|${prev.value})`;
      state.output += prev.value;
      continue;
    }

    /**
     * Braces
     */

    if (value === '{' && opts.nobrace !== true) {
      increment('braces');

      const open = {
        type: 'brace',
        value,
        output: '(',
        outputIndex: state.output.length,
        tokensIndex: state.tokens.length
      };

      braces.push(open);
      push(open);
      continue;
    }

    if (value === '}') {
      const brace = braces[braces.length - 1];

      if (opts.nobrace === true || !brace) {
        push({ type: 'text', value, output: value });
        continue;
      }

      let output = ')';

      if (brace.dots === true) {
        const arr = tokens.slice();
        const range = [];

        for (let i = arr.length - 1; i >= 0; i--) {
          tokens.pop();
          if (arr[i].type === 'brace') {
            break;
          }
          if (arr[i].type !== 'dots') {
            range.unshift(arr[i].value);
          }
        }

        output = expandRange(range, opts);
        state.backtrack = true;
      }

      if (brace.comma !== true && brace.dots !== true) {
        const out = state.output.slice(0, brace.outputIndex);
        const toks = state.tokens.slice(brace.tokensIndex);
        brace.value = brace.output = '\\{';
        value = output = '\\}';
        state.output = out;
        for (const t of toks) {
          state.output += (t.output || t.value);
        }
      }

      push({ type: 'brace', value, output });
      decrement('braces');
      braces.pop();
      continue;
    }

    /**
     * Pipes
     */

    if (value === '|') {
      if (extglobs.length > 0) {
        extglobs[extglobs.length - 1].conditions++;
      }
      push({ type: 'text', value });
      continue;
    }

    /**
     * Commas
     */

    if (value === ',') {
      let output = value;

      const brace = braces[braces.length - 1];
      if (brace && stack[stack.length - 1] === 'braces') {
        brace.comma = true;
        output = '|';
      }

      push({ type: 'comma', value, output });
      continue;
    }

    /**
     * Slashes
     */

    if (value === '/') {
      // if the beginning of the glob is "./", advance the start
      // to the current index, and don't add the "./" characters
      // to the state. This greatly simplifies lookbehinds when
      // checking for BOS characters like "!" and "." (not "./")
      if (prev.type === 'dot' && state.index === state.start + 1) {
        state.start = state.index + 1;
        state.consumed = '';
        state.output = '';
        tokens.pop();
        prev = bos; // reset "prev" to the first token
        continue;
      }

      push({ type: 'slash', value, output: SLASH_LITERAL });
      continue;
    }

    /**
     * Dots
     */

    if (value === '.') {
      if (state.braces > 0 && prev.type === 'dot') {
        if (prev.value === '.') prev.output = DOT_LITERAL;
        const brace = braces[braces.length - 1];
        prev.type = 'dots';
        prev.output += value;
        prev.value += value;
        brace.dots = true;
        continue;
      }

      if ((state.braces + state.parens) === 0 && prev.type !== 'bos' && prev.type !== 'slash') {
        push({ type: 'text', value, output: DOT_LITERAL });
        continue;
      }

      push({ type: 'dot', value, output: DOT_LITERAL });
      continue;
    }

    /**
     * Question marks
     */

    if (value === '?') {
      const isGroup = prev && prev.value === '(';
      if (!isGroup && opts.noextglob !== true && peek() === '(' && peek(2) !== '?') {
        extglobOpen('qmark', value);
        continue;
      }

      if (prev && prev.type === 'paren') {
        const next = peek();
        let output = value;

        if (next === '<' && !utils$2.supportsLookbehinds()) {
          throw new Error('Node.js v10 or higher is required for regex lookbehinds');
        }

        if ((prev.value === '(' && !/[!=<:]/.test(next)) || (next === '<' && !/<([!=]|\w+>)/.test(remaining()))) {
          output = `\\${value}`;
        }

        push({ type: 'text', value, output });
        continue;
      }

      if (opts.dot !== true && (prev.type === 'slash' || prev.type === 'bos')) {
        push({ type: 'qmark', value, output: QMARK_NO_DOT });
        continue;
      }

      push({ type: 'qmark', value, output: QMARK });
      continue;
    }

    /**
     * Exclamation
     */

    if (value === '!') {
      if (opts.noextglob !== true && peek() === '(') {
        if (peek(2) !== '?' || !/[!=<:]/.test(peek(3))) {
          extglobOpen('negate', value);
          continue;
        }
      }

      if (opts.nonegate !== true && state.index === 0) {
        negate();
        continue;
      }
    }

    /**
     * Plus
     */

    if (value === '+') {
      if (opts.noextglob !== true && peek() === '(' && peek(2) !== '?') {
        extglobOpen('plus', value);
        continue;
      }

      if ((prev && prev.value === '(') || opts.regex === false) {
        push({ type: 'plus', value, output: PLUS_LITERAL });
        continue;
      }

      if ((prev && (prev.type === 'bracket' || prev.type === 'paren' || prev.type === 'brace')) || state.parens > 0) {
        push({ type: 'plus', value });
        continue;
      }

      push({ type: 'plus', value: PLUS_LITERAL });
      continue;
    }

    /**
     * Plain text
     */

    if (value === '@') {
      if (opts.noextglob !== true && peek() === '(' && peek(2) !== '?') {
        push({ type: 'at', extglob: true, value, output: '' });
        continue;
      }

      push({ type: 'text', value });
      continue;
    }

    /**
     * Plain text
     */

    if (value !== '*') {
      if (value === '$' || value === '^') {
        value = `\\${value}`;
      }

      const match = REGEX_NON_SPECIAL_CHARS.exec(remaining());
      if (match) {
        value += match[0];
        state.index += match[0].length;
      }

      push({ type: 'text', value });
      continue;
    }

    /**
     * Stars
     */

    if (prev && (prev.type === 'globstar' || prev.star === true)) {
      prev.type = 'star';
      prev.star = true;
      prev.value += value;
      prev.output = star;
      state.backtrack = true;
      state.globstar = true;
      consume(value);
      continue;
    }

    let rest = remaining();
    if (opts.noextglob !== true && /^\([^?]/.test(rest)) {
      extglobOpen('star', value);
      continue;
    }

    if (prev.type === 'star') {
      if (opts.noglobstar === true) {
        consume(value);
        continue;
      }

      const prior = prev.prev;
      const before = prior.prev;
      const isStart = prior.type === 'slash' || prior.type === 'bos';
      const afterStar = before && (before.type === 'star' || before.type === 'globstar');

      if (opts.bash === true && (!isStart || (rest[0] && rest[0] !== '/'))) {
        push({ type: 'star', value, output: '' });
        continue;
      }

      const isBrace = state.braces > 0 && (prior.type === 'comma' || prior.type === 'brace');
      const isExtglob = extglobs.length && (prior.type === 'pipe' || prior.type === 'paren');
      if (!isStart && prior.type !== 'paren' && !isBrace && !isExtglob) {
        push({ type: 'star', value, output: '' });
        continue;
      }

      // strip consecutive `/**/`
      while (rest.slice(0, 3) === '/**') {
        const after = input[state.index + 4];
        if (after && after !== '/') {
          break;
        }
        rest = rest.slice(3);
        consume('/**', 3);
      }

      if (prior.type === 'bos' && eos()) {
        prev.type = 'globstar';
        prev.value += value;
        prev.output = globstar(opts);
        state.output = prev.output;
        state.globstar = true;
        consume(value);
        continue;
      }

      if (prior.type === 'slash' && prior.prev.type !== 'bos' && !afterStar && eos()) {
        state.output = state.output.slice(0, -(prior.output + prev.output).length);
        prior.output = `(?:${prior.output}`;

        prev.type = 'globstar';
        prev.output = globstar(opts) + (opts.strictSlashes ? ')' : '|$)');
        prev.value += value;
        state.globstar = true;
        state.output += prior.output + prev.output;
        consume(value);
        continue;
      }

      if (prior.type === 'slash' && prior.prev.type !== 'bos' && rest[0] === '/') {
        const end = rest[1] !== void 0 ? '|$' : '';

        state.output = state.output.slice(0, -(prior.output + prev.output).length);
        prior.output = `(?:${prior.output}`;

        prev.type = 'globstar';
        prev.output = `${globstar(opts)}${SLASH_LITERAL}|${SLASH_LITERAL}${end})`;
        prev.value += value;

        state.output += prior.output + prev.output;
        state.globstar = true;

        consume(value + advance());

        push({ type: 'slash', value: '/', output: '' });
        continue;
      }

      if (prior.type === 'bos' && rest[0] === '/') {
        prev.type = 'globstar';
        prev.value += value;
        prev.output = `(?:^|${SLASH_LITERAL}|${globstar(opts)}${SLASH_LITERAL})`;
        state.output = prev.output;
        state.globstar = true;
        consume(value + advance());
        push({ type: 'slash', value: '/', output: '' });
        continue;
      }

      // remove single star from output
      state.output = state.output.slice(0, -prev.output.length);

      // reset previous token to globstar
      prev.type = 'globstar';
      prev.output = globstar(opts);
      prev.value += value;

      // reset output with globstar
      state.output += prev.output;
      state.globstar = true;
      consume(value);
      continue;
    }

    const token = { type: 'star', value, output: star };

    if (opts.bash === true) {
      token.output = '.*?';
      if (prev.type === 'bos' || prev.type === 'slash') {
        token.output = nodot + token.output;
      }
      push(token);
      continue;
    }

    if (prev && (prev.type === 'bracket' || prev.type === 'paren') && opts.regex === true) {
      token.output = value;
      push(token);
      continue;
    }

    if (state.index === state.start || prev.type === 'slash' || prev.type === 'dot') {
      if (prev.type === 'dot') {
        state.output += NO_DOT_SLASH;
        prev.output += NO_DOT_SLASH;

      } else if (opts.dot === true) {
        state.output += NO_DOTS_SLASH;
        prev.output += NO_DOTS_SLASH;

      } else {
        state.output += nodot;
        prev.output += nodot;
      }

      if (peek() !== '*') {
        state.output += ONE_CHAR;
        prev.output += ONE_CHAR;
      }
    }

    push(token);
  }

  while (state.brackets > 0) {
    if (opts.strictBrackets === true) throw new SyntaxError(syntaxError('closing', ']'));
    state.output = utils$2.escapeLast(state.output, '[');
    decrement('brackets');
  }

  while (state.parens > 0) {
    if (opts.strictBrackets === true) throw new SyntaxError(syntaxError('closing', ')'));
    state.output = utils$2.escapeLast(state.output, '(');
    decrement('parens');
  }

  while (state.braces > 0) {
    if (opts.strictBrackets === true) throw new SyntaxError(syntaxError('closing', '}'));
    state.output = utils$2.escapeLast(state.output, '{');
    decrement('braces');
  }

  if (opts.strictSlashes !== true && (prev.type === 'star' || prev.type === 'bracket')) {
    push({ type: 'maybe_slash', value: '', output: `${SLASH_LITERAL}?` });
  }

  // rebuild the output if we had to backtrack at any point
  if (state.backtrack === true) {
    state.output = '';

    for (const token of state.tokens) {
      state.output += token.output != null ? token.output : token.value;

      if (token.suffix) {
        state.output += token.suffix;
      }
    }
  }

  return state;
};

/**
 * Fast paths for creating regular expressions for common glob patterns.
 * This can significantly speed up processing and has very little downside
 * impact when none of the fast paths match.
 */

parse$1.fastpaths = (input, options) => {
  const opts = { ...options };
  const max = typeof opts.maxLength === 'number' ? Math.min(MAX_LENGTH, opts.maxLength) : MAX_LENGTH;
  const len = input.length;
  if (len > max) {
    throw new SyntaxError(`Input length: ${len}, exceeds maximum allowed length: ${max}`);
  }

  input = REPLACEMENTS[input] || input;
  const win32 = utils$2.isWindows(options);

  // create constants based on platform, for windows or posix
  const {
    DOT_LITERAL,
    SLASH_LITERAL,
    ONE_CHAR,
    DOTS_SLASH,
    NO_DOT,
    NO_DOTS,
    NO_DOTS_SLASH,
    STAR,
    START_ANCHOR
  } = constants$1.globChars(win32);

  const nodot = opts.dot ? NO_DOTS : NO_DOT;
  const slashDot = opts.dot ? NO_DOTS_SLASH : NO_DOT;
  const capture = opts.capture ? '' : '?:';
  const state = { negated: false, prefix: '' };
  let star = opts.bash === true ? '.*?' : STAR;

  if (opts.capture) {
    star = `(${star})`;
  }

  const globstar = opts => {
    if (opts.noglobstar === true) return star;
    return `(${capture}(?:(?!${START_ANCHOR}${opts.dot ? DOTS_SLASH : DOT_LITERAL}).)*?)`;
  };

  const create = str => {
    switch (str) {
      case '*':
        return `${nodot}${ONE_CHAR}${star}`;

      case '.*':
        return `${DOT_LITERAL}${ONE_CHAR}${star}`;

      case '*.*':
        return `${nodot}${star}${DOT_LITERAL}${ONE_CHAR}${star}`;

      case '*/*':
        return `${nodot}${star}${SLASH_LITERAL}${ONE_CHAR}${slashDot}${star}`;

      case '**':
        return nodot + globstar(opts);

      case '**/*':
        return `(?:${nodot}${globstar(opts)}${SLASH_LITERAL})?${slashDot}${ONE_CHAR}${star}`;

      case '**/*.*':
        return `(?:${nodot}${globstar(opts)}${SLASH_LITERAL})?${slashDot}${star}${DOT_LITERAL}${ONE_CHAR}${star}`;

      case '**/.*':
        return `(?:${nodot}${globstar(opts)}${SLASH_LITERAL})?${DOT_LITERAL}${ONE_CHAR}${star}`;

      default: {
        const match = /^(.*?)\.(\w+)$/.exec(str);
        if (!match) return;

        const source = create(match[1]);
        if (!source) return;

        return source + DOT_LITERAL + match[2];
      }
    }
  };

  const output = utils$2.removePrefix(input, state);
  let source = create(output);

  if (source && opts.strictSlashes !== true) {
    source += `${SLASH_LITERAL}?`;
  }

  return source;
};

var parse_1 = parse$1;

const path = path$2;
const scan = scan_1;
const parse = parse_1;
const utils$1 = utils$4;
const constants = constants$2;
const isObject = val => val && typeof val === 'object' && !Array.isArray(val);

/**
 * Creates a matcher function from one or more glob patterns. The
 * returned function takes a string to match as its first argument,
 * and returns true if the string is a match. The returned matcher
 * function also takes a boolean as the second argument that, when true,
 * returns an object with additional information.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch(glob[, options]);
 *
 * const isMatch = picomatch('*.!(*a)');
 * console.log(isMatch('a.a')); //=> false
 * console.log(isMatch('a.b')); //=> true
 * ```
 * @name picomatch
 * @param {String|Array} `globs` One or more glob patterns.
 * @param {Object=} `options`
 * @return {Function=} Returns a matcher function.
 * @api public
 */

const picomatch$1 = (glob, options, returnState = false) => {
  if (Array.isArray(glob)) {
    const fns = glob.map(input => picomatch$1(input, options, returnState));
    const arrayMatcher = str => {
      for (const isMatch of fns) {
        const state = isMatch(str);
        if (state) return state;
      }
      return false;
    };
    return arrayMatcher;
  }

  const isState = isObject(glob) && glob.tokens && glob.input;

  if (glob === '' || (typeof glob !== 'string' && !isState)) {
    throw new TypeError('Expected pattern to be a non-empty string');
  }

  const opts = options || {};
  const posix = utils$1.isWindows(options);
  const regex = isState
    ? picomatch$1.compileRe(glob, options)
    : picomatch$1.makeRe(glob, options, false, true);

  const state = regex.state;
  delete regex.state;

  let isIgnored = () => false;
  if (opts.ignore) {
    const ignoreOpts = { ...options, ignore: null, onMatch: null, onResult: null };
    isIgnored = picomatch$1(opts.ignore, ignoreOpts, returnState);
  }

  const matcher = (input, returnObject = false) => {
    const { isMatch, match, output } = picomatch$1.test(input, regex, options, { glob, posix });
    const result = { glob, state, regex, posix, input, output, match, isMatch };

    if (typeof opts.onResult === 'function') {
      opts.onResult(result);
    }

    if (isMatch === false) {
      result.isMatch = false;
      return returnObject ? result : false;
    }

    if (isIgnored(input)) {
      if (typeof opts.onIgnore === 'function') {
        opts.onIgnore(result);
      }
      result.isMatch = false;
      return returnObject ? result : false;
    }

    if (typeof opts.onMatch === 'function') {
      opts.onMatch(result);
    }
    return returnObject ? result : true;
  };

  if (returnState) {
    matcher.state = state;
  }

  return matcher;
};

/**
 * Test `input` with the given `regex`. This is used by the main
 * `picomatch()` function to test the input string.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.test(input, regex[, options]);
 *
 * console.log(picomatch.test('foo/bar', /^(?:([^/]*?)\/([^/]*?))$/));
 * // { isMatch: true, match: [ 'foo/', 'foo', 'bar' ], output: 'foo/bar' }
 * ```
 * @param {String} `input` String to test.
 * @param {RegExp} `regex`
 * @return {Object} Returns an object with matching info.
 * @api public
 */

picomatch$1.test = (input, regex, options, { glob, posix } = {}) => {
  if (typeof input !== 'string') {
    throw new TypeError('Expected input to be a string');
  }

  if (input === '') {
    return { isMatch: false, output: '' };
  }

  const opts = options || {};
  const format = opts.format || (posix ? utils$1.toPosixSlashes : null);
  let match = input === glob;
  let output = (match && format) ? format(input) : input;

  if (match === false) {
    output = format ? format(input) : input;
    match = output === glob;
  }

  if (match === false || opts.capture === true) {
    if (opts.matchBase === true || opts.basename === true) {
      match = picomatch$1.matchBase(input, regex, options, posix);
    } else {
      match = regex.exec(output);
    }
  }

  return { isMatch: Boolean(match), match, output };
};

/**
 * Match the basename of a filepath.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.matchBase(input, glob[, options]);
 * console.log(picomatch.matchBase('foo/bar.js', '*.js'); // true
 * ```
 * @param {String} `input` String to test.
 * @param {RegExp|String} `glob` Glob pattern or regex created by [.makeRe](#makeRe).
 * @return {Boolean}
 * @api public
 */

picomatch$1.matchBase = (input, glob, options, posix = utils$1.isWindows(options)) => {
  const regex = glob instanceof RegExp ? glob : picomatch$1.makeRe(glob, options);
  return regex.test(path.basename(input));
};

/**
 * Returns true if **any** of the given glob `patterns` match the specified `string`.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.isMatch(string, patterns[, options]);
 *
 * console.log(picomatch.isMatch('a.a', ['b.*', '*.a'])); //=> true
 * console.log(picomatch.isMatch('a.a', 'b.*')); //=> false
 * ```
 * @param {String|Array} str The string to test.
 * @param {String|Array} patterns One or more glob patterns to use for matching.
 * @param {Object} [options] See available [options](#options).
 * @return {Boolean} Returns true if any patterns match `str`
 * @api public
 */

picomatch$1.isMatch = (str, patterns, options) => picomatch$1(patterns, options)(str);

/**
 * Parse a glob pattern to create the source string for a regular
 * expression.
 *
 * ```js
 * const picomatch = require('picomatch');
 * const result = picomatch.parse(pattern[, options]);
 * ```
 * @param {String} `pattern`
 * @param {Object} `options`
 * @return {Object} Returns an object with useful properties and output to be used as a regex source string.
 * @api public
 */

picomatch$1.parse = (pattern, options) => {
  if (Array.isArray(pattern)) return pattern.map(p => picomatch$1.parse(p, options));
  return parse(pattern, { ...options, fastpaths: false });
};

/**
 * Scan a glob pattern to separate the pattern into segments.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.scan(input[, options]);
 *
 * const result = picomatch.scan('!./foo/*.js');
 * console.log(result);
 * { prefix: '!./',
 *   input: '!./foo/*.js',
 *   start: 3,
 *   base: 'foo',
 *   glob: '*.js',
 *   isBrace: false,
 *   isBracket: false,
 *   isGlob: true,
 *   isExtglob: false,
 *   isGlobstar: false,
 *   negated: true }
 * ```
 * @param {String} `input` Glob pattern to scan.
 * @param {Object} `options`
 * @return {Object} Returns an object with
 * @api public
 */

picomatch$1.scan = (input, options) => scan(input, options);

/**
 * Compile a regular expression from the `state` object returned by the
 * [parse()](#parse) method.
 *
 * @param {Object} `state`
 * @param {Object} `options`
 * @param {Boolean} `returnOutput` Intended for implementors, this argument allows you to return the raw output from the parser.
 * @param {Boolean} `returnState` Adds the state to a `state` property on the returned regex. Useful for implementors and debugging.
 * @return {RegExp}
 * @api public
 */

picomatch$1.compileRe = (state, options, returnOutput = false, returnState = false) => {
  if (returnOutput === true) {
    return state.output;
  }

  const opts = options || {};
  const prepend = opts.contains ? '' : '^';
  const append = opts.contains ? '' : '$';

  let source = `${prepend}(?:${state.output})${append}`;
  if (state && state.negated === true) {
    source = `^(?!${source}).*$`;
  }

  const regex = picomatch$1.toRegex(source, options);
  if (returnState === true) {
    regex.state = state;
  }

  return regex;
};

/**
 * Create a regular expression from a parsed glob pattern.
 *
 * ```js
 * const picomatch = require('picomatch');
 * const state = picomatch.parse('*.js');
 * // picomatch.compileRe(state[, options]);
 *
 * console.log(picomatch.compileRe(state));
 * //=> /^(?:(?!\.)(?=.)[^/]*?\.js)$/
 * ```
 * @param {String} `state` The object returned from the `.parse` method.
 * @param {Object} `options`
 * @param {Boolean} `returnOutput` Implementors may use this argument to return the compiled output, instead of a regular expression. This is not exposed on the options to prevent end-users from mutating the result.
 * @param {Boolean} `returnState` Implementors may use this argument to return the state from the parsed glob with the returned regular expression.
 * @return {RegExp} Returns a regex created from the given pattern.
 * @api public
 */

picomatch$1.makeRe = (input, options = {}, returnOutput = false, returnState = false) => {
  if (!input || typeof input !== 'string') {
    throw new TypeError('Expected a non-empty string');
  }

  let parsed = { negated: false, fastpaths: true };

  if (options.fastpaths !== false && (input[0] === '.' || input[0] === '*')) {
    parsed.output = parse.fastpaths(input, options);
  }

  if (!parsed.output) {
    parsed = parse(input, options);
  }

  return picomatch$1.compileRe(parsed, options, returnOutput, returnState);
};

/**
 * Create a regular expression from the given regex source string.
 *
 * ```js
 * const picomatch = require('picomatch');
 * // picomatch.toRegex(source[, options]);
 *
 * const { output } = picomatch.parse('*.js');
 * console.log(picomatch.toRegex(output));
 * //=> /^(?:(?!\.)(?=.)[^/]*?\.js)$/
 * ```
 * @param {String} `source` Regular expression source string.
 * @param {Object} `options`
 * @return {RegExp}
 * @api public
 */

picomatch$1.toRegex = (source, options) => {
  try {
    const opts = options || {};
    return new RegExp(source, opts.flags || (opts.nocase ? 'i' : ''));
  } catch (err) {
    if (options && options.debug === true) throw err;
    return /$^/;
  }
};

/**
 * Picomatch constants.
 * @return {Object}
 */

picomatch$1.constants = constants;

/**
 * Expose "picomatch"
 */

var picomatch_1 = picomatch$1;

(function (module) {

	module.exports = picomatch_1;
} (picomatch$2));

const util = empty;
const braces = braces_1;
const picomatch = picomatch$2.exports;
const utils = utils$4;
const isEmptyString = val => val === '' || val === './';

/**
 * Returns an array of strings that match one or more glob patterns.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm(list, patterns[, options]);
 *
 * console.log(mm(['a.js', 'a.txt'], ['*.js']));
 * //=> [ 'a.js' ]
 * ```
 * @param {String|Array<string>} `list` List of strings to match.
 * @param {String|Array<string>} `patterns` One or more glob patterns to use for matching.
 * @param {Object} `options` See available [options](#options)
 * @return {Array} Returns an array of matches
 * @summary false
 * @api public
 */

const micromatch = (list, patterns, options) => {
  patterns = [].concat(patterns);
  list = [].concat(list);

  let omit = new Set();
  let keep = new Set();
  let items = new Set();
  let negatives = 0;

  let onResult = state => {
    items.add(state.output);
    if (options && options.onResult) {
      options.onResult(state);
    }
  };

  for (let i = 0; i < patterns.length; i++) {
    let isMatch = picomatch(String(patterns[i]), { ...options, onResult }, true);
    let negated = isMatch.state.negated || isMatch.state.negatedExtglob;
    if (negated) negatives++;

    for (let item of list) {
      let matched = isMatch(item, true);

      let match = negated ? !matched.isMatch : matched.isMatch;
      if (!match) continue;

      if (negated) {
        omit.add(matched.output);
      } else {
        omit.delete(matched.output);
        keep.add(matched.output);
      }
    }
  }

  let result = negatives === patterns.length ? [...items] : [...keep];
  let matches = result.filter(item => !omit.has(item));

  if (options && matches.length === 0) {
    if (options.failglob === true) {
      throw new Error(`No matches found for "${patterns.join(', ')}"`);
    }

    if (options.nonull === true || options.nullglob === true) {
      return options.unescape ? patterns.map(p => p.replace(/\\/g, '')) : patterns;
    }
  }

  return matches;
};

/**
 * Backwards compatibility
 */

micromatch.match = micromatch;

/**
 * Returns a matcher function from the given glob `pattern` and `options`.
 * The returned function takes a string to match as its only argument and returns
 * true if the string is a match.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm.matcher(pattern[, options]);
 *
 * const isMatch = mm.matcher('*.!(*a)');
 * console.log(isMatch('a.a')); //=> false
 * console.log(isMatch('a.b')); //=> true
 * ```
 * @param {String} `pattern` Glob pattern
 * @param {Object} `options`
 * @return {Function} Returns a matcher function.
 * @api public
 */

micromatch.matcher = (pattern, options) => picomatch(pattern, options);

/**
 * Returns true if **any** of the given glob `patterns` match the specified `string`.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm.isMatch(string, patterns[, options]);
 *
 * console.log(mm.isMatch('a.a', ['b.*', '*.a'])); //=> true
 * console.log(mm.isMatch('a.a', 'b.*')); //=> false
 * ```
 * @param {String} `str` The string to test.
 * @param {String|Array} `patterns` One or more glob patterns to use for matching.
 * @param {Object} `[options]` See available [options](#options).
 * @return {Boolean} Returns true if any patterns match `str`
 * @api public
 */

micromatch.isMatch = (str, patterns, options) => picomatch(patterns, options)(str);

/**
 * Backwards compatibility
 */

micromatch.any = micromatch.isMatch;

/**
 * Returns a list of strings that _**do not match any**_ of the given `patterns`.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm.not(list, patterns[, options]);
 *
 * console.log(mm.not(['a.a', 'b.b', 'c.c'], '*.a'));
 * //=> ['b.b', 'c.c']
 * ```
 * @param {Array} `list` Array of strings to match.
 * @param {String|Array} `patterns` One or more glob pattern to use for matching.
 * @param {Object} `options` See available [options](#options) for changing how matches are performed
 * @return {Array} Returns an array of strings that **do not match** the given patterns.
 * @api public
 */

micromatch.not = (list, patterns, options = {}) => {
  patterns = [].concat(patterns).map(String);
  let result = new Set();
  let items = [];

  let onResult = state => {
    if (options.onResult) options.onResult(state);
    items.push(state.output);
  };

  let matches = new Set(micromatch(list, patterns, { ...options, onResult }));

  for (let item of items) {
    if (!matches.has(item)) {
      result.add(item);
    }
  }
  return [...result];
};

/**
 * Returns true if the given `string` contains the given pattern. Similar
 * to [.isMatch](#isMatch) but the pattern can match any part of the string.
 *
 * ```js
 * var mm = require('micromatch');
 * // mm.contains(string, pattern[, options]);
 *
 * console.log(mm.contains('aa/bb/cc', '*b'));
 * //=> true
 * console.log(mm.contains('aa/bb/cc', '*d'));
 * //=> false
 * ```
 * @param {String} `str` The string to match.
 * @param {String|Array} `patterns` Glob pattern to use for matching.
 * @param {Object} `options` See available [options](#options) for changing how matches are performed
 * @return {Boolean} Returns true if any of the patterns matches any part of `str`.
 * @api public
 */

micromatch.contains = (str, pattern, options) => {
  if (typeof str !== 'string') {
    throw new TypeError(`Expected a string: "${util.inspect(str)}"`);
  }

  if (Array.isArray(pattern)) {
    return pattern.some(p => micromatch.contains(str, p, options));
  }

  if (typeof pattern === 'string') {
    if (isEmptyString(str) || isEmptyString(pattern)) {
      return false;
    }

    if (str.includes(pattern) || (str.startsWith('./') && str.slice(2).includes(pattern))) {
      return true;
    }
  }

  return micromatch.isMatch(str, pattern, { ...options, contains: true });
};

/**
 * Filter the keys of the given object with the given `glob` pattern
 * and `options`. Does not attempt to match nested keys. If you need this feature,
 * use [glob-object][] instead.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm.matchKeys(object, patterns[, options]);
 *
 * const obj = { aa: 'a', ab: 'b', ac: 'c' };
 * console.log(mm.matchKeys(obj, '*b'));
 * //=> { ab: 'b' }
 * ```
 * @param {Object} `object` The object with keys to filter.
 * @param {String|Array} `patterns` One or more glob patterns to use for matching.
 * @param {Object} `options` See available [options](#options) for changing how matches are performed
 * @return {Object} Returns an object with only keys that match the given patterns.
 * @api public
 */

micromatch.matchKeys = (obj, patterns, options) => {
  if (!utils.isObject(obj)) {
    throw new TypeError('Expected the first argument to be an object');
  }
  let keys = micromatch(Object.keys(obj), patterns, options);
  let res = {};
  for (let key of keys) res[key] = obj[key];
  return res;
};

/**
 * Returns true if some of the strings in the given `list` match any of the given glob `patterns`.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm.some(list, patterns[, options]);
 *
 * console.log(mm.some(['foo.js', 'bar.js'], ['*.js', '!foo.js']));
 * // true
 * console.log(mm.some(['foo.js'], ['*.js', '!foo.js']));
 * // false
 * ```
 * @param {String|Array} `list` The string or array of strings to test. Returns as soon as the first match is found.
 * @param {String|Array} `patterns` One or more glob patterns to use for matching.
 * @param {Object} `options` See available [options](#options) for changing how matches are performed
 * @return {Boolean} Returns true if any `patterns` matches any of the strings in `list`
 * @api public
 */

micromatch.some = (list, patterns, options) => {
  let items = [].concat(list);

  for (let pattern of [].concat(patterns)) {
    let isMatch = picomatch(String(pattern), options);
    if (items.some(item => isMatch(item))) {
      return true;
    }
  }
  return false;
};

/**
 * Returns true if every string in the given `list` matches
 * any of the given glob `patterns`.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm.every(list, patterns[, options]);
 *
 * console.log(mm.every('foo.js', ['foo.js']));
 * // true
 * console.log(mm.every(['foo.js', 'bar.js'], ['*.js']));
 * // true
 * console.log(mm.every(['foo.js', 'bar.js'], ['*.js', '!foo.js']));
 * // false
 * console.log(mm.every(['foo.js'], ['*.js', '!foo.js']));
 * // false
 * ```
 * @param {String|Array} `list` The string or array of strings to test.
 * @param {String|Array} `patterns` One or more glob patterns to use for matching.
 * @param {Object} `options` See available [options](#options) for changing how matches are performed
 * @return {Boolean} Returns true if all `patterns` matches all of the strings in `list`
 * @api public
 */

micromatch.every = (list, patterns, options) => {
  let items = [].concat(list);

  for (let pattern of [].concat(patterns)) {
    let isMatch = picomatch(String(pattern), options);
    if (!items.every(item => isMatch(item))) {
      return false;
    }
  }
  return true;
};

/**
 * Returns true if **all** of the given `patterns` match
 * the specified string.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm.all(string, patterns[, options]);
 *
 * console.log(mm.all('foo.js', ['foo.js']));
 * // true
 *
 * console.log(mm.all('foo.js', ['*.js', '!foo.js']));
 * // false
 *
 * console.log(mm.all('foo.js', ['*.js', 'foo.js']));
 * // true
 *
 * console.log(mm.all('foo.js', ['*.js', 'f*', '*o*', '*o.js']));
 * // true
 * ```
 * @param {String|Array} `str` The string to test.
 * @param {String|Array} `patterns` One or more glob patterns to use for matching.
 * @param {Object} `options` See available [options](#options) for changing how matches are performed
 * @return {Boolean} Returns true if any patterns match `str`
 * @api public
 */

micromatch.all = (str, patterns, options) => {
  if (typeof str !== 'string') {
    throw new TypeError(`Expected a string: "${util.inspect(str)}"`);
  }

  return [].concat(patterns).every(p => picomatch(p, options)(str));
};

/**
 * Returns an array of matches captured by `pattern` in `string, or `null` if the pattern did not match.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm.capture(pattern, string[, options]);
 *
 * console.log(mm.capture('test/*.js', 'test/foo.js'));
 * //=> ['foo']
 * console.log(mm.capture('test/*.js', 'foo/bar.css'));
 * //=> null
 * ```
 * @param {String} `glob` Glob pattern to use for matching.
 * @param {String} `input` String to match
 * @param {Object} `options` See available [options](#options) for changing how matches are performed
 * @return {Array|null} Returns an array of captures if the input matches the glob pattern, otherwise `null`.
 * @api public
 */

micromatch.capture = (glob, input, options) => {
  let posix = utils.isWindows(options);
  let regex = picomatch.makeRe(String(glob), { ...options, capture: true });
  let match = regex.exec(posix ? utils.toPosixSlashes(input) : input);

  if (match) {
    return match.slice(1).map(v => v === void 0 ? '' : v);
  }
};

/**
 * Create a regular expression from the given glob `pattern`.
 *
 * ```js
 * const mm = require('micromatch');
 * // mm.makeRe(pattern[, options]);
 *
 * console.log(mm.makeRe('*.js'));
 * //=> /^(?:(\.[\\\/])?(?!\.)(?=.)[^\/]*?\.js)$/
 * ```
 * @param {String} `pattern` A glob pattern to convert to regex.
 * @param {Object} `options`
 * @return {RegExp} Returns a regex created from the given pattern.
 * @api public
 */

micromatch.makeRe = (...args) => picomatch.makeRe(...args);

/**
 * Scan a glob pattern to separate the pattern into segments. Used
 * by the [split](#split) method.
 *
 * ```js
 * const mm = require('micromatch');
 * const state = mm.scan(pattern[, options]);
 * ```
 * @param {String} `pattern`
 * @param {Object} `options`
 * @return {Object} Returns an object with
 * @api public
 */

micromatch.scan = (...args) => picomatch.scan(...args);

/**
 * Parse a glob pattern to create the source string for a regular
 * expression.
 *
 * ```js
 * const mm = require('micromatch');
 * const state = mm.parse(pattern[, options]);
 * ```
 * @param {String} `glob`
 * @param {Object} `options`
 * @return {Object} Returns an object with useful properties and output to be used as regex source string.
 * @api public
 */

micromatch.parse = (patterns, options) => {
  let res = [];
  for (let pattern of [].concat(patterns || [])) {
    for (let str of braces(String(pattern), options)) {
      res.push(picomatch.parse(str, options));
    }
  }
  return res;
};

/**
 * Process the given brace `pattern`.
 *
 * ```js
 * const { braces } = require('micromatch');
 * console.log(braces('foo/{a,b,c}/bar'));
 * //=> [ 'foo/(a|b|c)/bar' ]
 *
 * console.log(braces('foo/{a,b,c}/bar', { expand: true }));
 * //=> [ 'foo/a/bar', 'foo/b/bar', 'foo/c/bar' ]
 * ```
 * @param {String} `pattern` String with brace pattern to process.
 * @param {Object} `options` Any [options](#options) to change how expansion is performed. See the [braces][] library for all available options.
 * @return {Array}
 * @api public
 */

micromatch.braces = (pattern, options) => {
  if (typeof pattern !== 'string') throw new TypeError('Expected a string');
  if ((options && options.nobrace === true) || !/\{.*\}/.test(pattern)) {
    return [pattern];
  }
  return braces(pattern, options);
};

/**
 * Expand braces
 */

micromatch.braceExpand = (pattern, options) => {
  if (typeof pattern !== 'string') throw new TypeError('Expected a string');
  return micromatch.braces(pattern, { ...options, expand: true });
};

/**
 * Expose micromatch
 */

var micromatch_1 = micromatch;

function expandGroup(parentGroup) {
    return flattenGroup(parentGroup).map(g => ({
        name: g.name,
        expandedName: g.expandedName,
        properties: g.properties
    }));
}
function flattenGroup(group) {
    let groups = [group];
    (group.groups || []).forEach(sg => {
        groups = groups.concat(flattenGroup(sg));
    });
    return groups;
}
function addExpandedNameToGroups(group, parentGroupExpandedName) {
    const g = group;
    g.expandedName = parentGroupExpandedName ? `${parentGroupExpandedName}/${g.name}` : g.name;
    (g.groups || []).forEach(sg => addExpandedNameToGroups(sg, g.expandedName));
    return g;
}
function expandMutation(mutation, groups, cache) {
    const matchers = [];
    mutation.matchers.map(mat => {
        groupGlobFilter(groups, mat.glob, cache).forEach(expandedName => {
            matchers.push({
                group: expandedName
            });
        });
    });
    return { transformations: mutation.transformations, matchers };
}
function expandCollection(collection, groups, cache) {
    const expandedGroups = {};
    for (const key in collection.groups) {
        const groupGlob = collection.groups[key];
        expandedGroups[key] = groupGlobFilter(groups, groupGlob, cache);
    }
    return {
        name: collection.name,
        groups: expandedGroups
    };
}
// Takes groups and a glob, and returns expanded names of matching groups
function groupGlobFilter(groups, glob, cache) {
    var _a;
    if ((_a = cache === null || cache === void 0 ? void 0 : cache.globs) === null || _a === void 0 ? void 0 : _a.has(glob))
        return cache.globs.get(glob);
    const result = micromatch_1(groups.map(g => g.expandedName), glob);
    if (cache === null || cache === void 0 ? void 0 : cache.globs)
        cache.globs.set(glob, result);
    return result;
}

function getChosenAndUnchosenGroups(collection, choice, groups) {
    const chosen = [];
    const unchosen = [];
    const defaults = [];
    const keys = getOtherGroupsFromCollectionChoice(collection, choice);
    keys.unchosen.forEach(n => {
        const group = groups.find(g => g.expandedName === n);
        unchosen.push(group);
    });
    keys.chosen.forEach(n => {
        const group = groups.find(g => g.expandedName === n);
        chosen.push(group);
    });
    if (keys.defaults) {
        keys.defaults.forEach(n => {
            const group = groups.find(g => g.expandedName === n);
            defaults.push(group);
        });
    }
    return { unchosen, chosen, defaults };
}
function getOtherGroupsFromCollectionChoice(c, choice) {
    let chosen = []; // array of expanded group names
    let unchosen = [];
    const [unchosenKeys, chosenKeys] = partition(Object.keys(c.groups), k => choice.keys.indexOf(k) < 0);
    unchosenKeys.forEach(k => {
        if (k !== '_default')
            unchosen = unchosen.concat(c.groups[k]);
    });
    chosenKeys.forEach(k => {
        chosen = chosen.concat(c.groups[k]);
    });
    return { chosen, unchosen, defaults: c.groups['_default'] };
}
function partition(array, isValid) {
    return array.reduce(([pass, fail], elem) => {
        return isValid(elem) ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    }, [[], []]);
}

function formulaScriptToFormula(script, evalContext) {
    const head = '(function(){\n' +
        '"use strict"\n' +
        'var ɵexport = undefined;\n' +
        'var ɵmodule = {};\n' +
        'Object.defineProperty(ɵmodule, "exports", {\n' +
        'set: function(v) { ɵexport = v; }\n' +
        '});\n' +
        '(function(module){\n';
    const tail = '})(ɵmodule);\n' +
        'return ɵexport;' +
        '})();';
    const generateFunc = evalContext.eval(`${head}\n${script.generateFunction}\n${tail}`);
    const formula = {
        name: script.name,
        args: script.args,
        required: script.required,
        generate: generateFunc
    };
    return formula;
}

function entries(obj) {
    let ownProps = Object.keys(obj), i = ownProps.length, resArray = new Array(i); // preallocate the Array
    while (i--)
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
    return resArray;
}

const buildCache = (keys, precompiledCache) => {
    const cache = {};
    for (let key of keys) {
        if (key === 'elements') {
            cache.elements = new Map();
        }
        else if (key === 'globs') {
            cache.globs = new Map(entries(precompiledCache.precompiledGlobs || {}));
        }
    }
    return cache;
};

class Transfo {
    constructor() {
        this.formulaRegistry = {};
        this.formulaEvalEnabled = false;
        this.remoteSvgsEnabled = false;
        this.choiceMode = ChoiceMode.Delete;
        this.elementTransformers = [];
    }
    async transform(command) {
        let groups = [];
        command.groups
            .map(g => addExpandedNameToGroups(g))
            .map(g => expandGroup(g))
            .forEach(gs => groups = groups.concat(gs));
        const formulaRegistry = { ...this.formulaRegistry };
        if (this.formulaEvalEnabled) {
            if (this.formulaEvalContext) {
                addFormulaScripts(command.formulas || [], formulaRegistry, this.formulaEvalContext);
            }
            else {
                throw new TransfoError('Formula eval context not set', 4 /* TransfoErrorType.FEATURE_EVAL_CONTEXT_NOT_SET_ERROR */);
            }
        }
        else if (command.formulas) {
            throw new TransfoError('Formula eval not enabled', 3 /* TransfoErrorType.FEATURE_EVAL_DISABLED_ERROR */);
        }
        const runArguments = {
            r: command.run && command.run.arguments || {}
        };
        const derivative = command.run && command.run.derivative && command.run.derivative !== 'main' ?
            command.run.derivative : null;
        const results = await Promise.all(command.svgs.map(async (svg) => {
            let inlineSvg;
            if (isInlineSvg(svg) || (this.domWrapper.keepContent && !derivative)) {
                if (derivative) {
                    const svgDerivative = svg.derivatives ? svg.derivatives[derivative] : null;
                    if (!svgDerivative)
                        throw new TransfoError(`SVG derivative not found: ${derivative}`, 5 /* TransfoErrorType.SVG_DERIVATIVE_NOT_FOUND_ERROR */);
                    if (!isInlineSvg(svgDerivative))
                        throw new TransfoError('SVG derivative not inline', 6 /* TransfoErrorType.SVG_DERIVATIVE_NOT_INLINE_ERROR */);
                    inlineSvg = { name: svg.name, content: svgDerivative.content };
                }
                else {
                    inlineSvg = svg;
                }
            }
            else if (this.remoteSvgsEnabled) {
                if (!this.downloader)
                    throw new TransfoError('Downloader not set', 8 /* TransfoErrorType.FEATURE_DOWNLOADER_NOT_SET */);
                let contentUrl;
                if (derivative) {
                    const svgDerivative = svg.derivatives ? svg.derivatives[derivative] : null;
                    if (!svgDerivative)
                        throw new TransfoError(`SVG derivative not found: ${derivative}`, 5 /* TransfoErrorType.SVG_DERIVATIVE_NOT_FOUND_ERROR */);
                    if (isInlineSvg(svgDerivative))
                        throw new TransfoError('SVG derivative not remote', 7 /* TransfoErrorType.SVG_DERIVATIVE_NOT_REMOTE_ERROR */);
                    contentUrl = derivative ? svgDerivative.contentUrl : svg.contentUrl;
                }
                else {
                    contentUrl = svg.contentUrl;
                }
                inlineSvg = {
                    name: svg.name,
                    content: await this.downloader.download(contentUrl)
                };
            }
            else {
                throw new TransfoError('Remote SVG downloading not enabled', 9 /* TransfoErrorType.FEATURE_REMOTE_SVG_DOWNLOADING_DISABLED */);
            }
            const parseResult = this.domWrapper.parse(this.domWrapper.keepContent ? null : inlineSvg.content);
            const { root, $ } = parseResult;
            this.elementTransformers.forEach(tr => {
                root.find('svg, g, symbol, [id]').each((i, el) => tr.transform(el, $));
            });
            return { parseResult, name: svg.name };
        }));
        const expandedMutations = command.mutations.map(m => expandMutation(m, groups, this.cache));
        const mutations = expandedMutations.map(m => interpolateMutation(m, runArguments));
        const collections = command.collections.map(c => expandCollection(c, groups, this.cache));
        const instructions = link(groups, command.transformations, mutations, formulaRegistry);
        const choices = command.choices.map(c => interpolateChoice(c, runArguments));
        const groupChoices = collections.map(c => {
            return getChosenAndUnchosenGroups(c, choices.find(ch => ch.collection === c.name), groups);
        });
        const baseUrl = (command.run && command.run.baseUrl) || '';
        results.forEach(r => {
            const { parseResult } = r;
            modifyDom(parseResult, instructions, groupChoices, this.choiceMode, baseUrl, this.cache ? this.cache.elements : null);
        });
        return results.map(({ name, parseResult }) => {
            const content = this.domWrapper.keepContent ? null : parseResult.root.html();
            return { name, content };
        });
    }
    registerFormula(formula) {
        this.formulaRegistry[formula.name] = formula;
        return this;
    }
    setDomWrapper(domWrapper) {
        this.domWrapper = domWrapper;
        return this;
    }
    enableFormulaEval() {
        this.formulaEvalEnabled = true;
        return this;
    }
    setFormulaEvalContext(formulaEvalContext) {
        this.formulaEvalContext = formulaEvalContext;
        return this;
    }
    enableRemoteSvgs() {
        this.remoteSvgsEnabled = true;
        return this;
    }
    setChoiceMode(mode) {
        this.choiceMode = mode;
        return this;
    }
    setDownloader(downloader) {
        this.downloader = downloader;
        return this;
    }
    addElementTransformer(elementTransformer) {
        this.elementTransformers.push(elementTransformer);
        return this;
    }
    buildCache(keys, precompiledCache) {
        const builtCache = buildCache(keys, precompiledCache || {});
        const currentCache = this.cache || {};
        this.cache = { ...currentCache, ...builtCache };
        return this;
    }
    resetCache() {
        this.cache = {};
    }
}
function interpolateMutation(mutation, runArguments) {
    const m = {
        matchers: mutation.matchers,
        transformations: mutation.transformations.map(t => ({ name: t.name, arguments: t.arguments ? interpolateArguments(t.arguments, runArguments) : {} }))
    };
    return m;
}
function interpolateChoice(choice, runArguments) {
    const c = {
        collection: choice.collection,
        keys: interpolateArgumentsArray(choice.keys, runArguments)
    };
    return c;
}
function addFormulaScripts(scripts, registry, evalContext) {
    scripts.forEach(script => {
        registry[script.name] = formulaScriptToFormula(script, evalContext);
    });
}
function isInlineSvg(svg) {
    return svg.hasOwnProperty('content');
}

const eval2 = eval;
class BrowserEvalContext {
    eval(code) {
        // From https://rollupjs.org/guide/en#avoiding-eval
        return (function () {
            return eval2(code);
        })();
    }
}

var cash$1 = {exports: {}};

(function (module, exports) {
	(function(){
	var doc = document;
	var win = window;
	var docEle = doc.documentElement;
	var createElement = doc.createElement.bind(doc);
	var div = createElement('div');
	var table = createElement('table');
	var tbody = createElement('tbody');
	var tr = createElement('tr');
	var isArray = Array.isArray, ArrayPrototype = Array.prototype;
	var concat = ArrayPrototype.concat, filter = ArrayPrototype.filter, indexOf = ArrayPrototype.indexOf, map = ArrayPrototype.map, push = ArrayPrototype.push, slice = ArrayPrototype.slice, some = ArrayPrototype.some, splice = ArrayPrototype.splice;
	var idRe = /^#(?:[\w-]|\\.|[^\x00-\xa0])*$/;
	var classRe = /^\.(?:[\w-]|\\.|[^\x00-\xa0])*$/;
	var htmlRe = /<.+>/;
	var tagRe = /^\w+$/;
	// @require ./variables.ts
	function find(selector, context) {
	    var isFragment = isDocumentFragment(context);
	    return !selector || (!isFragment && !isDocument(context) && !isElement(context))
	        ? []
	        : !isFragment && classRe.test(selector)
	            ? context.getElementsByClassName(selector.slice(1).replace(/\\/g, ''))
	            : !isFragment && tagRe.test(selector)
	                ? context.getElementsByTagName(selector)
	                : context.querySelectorAll(selector);
	}
	// @require ./find.ts
	// @require ./variables.ts
	var Cash = /** @class */ (function () {
	    function Cash(selector, context) {
	        if (!selector)
	            return;
	        if (isCash(selector))
	            return selector;
	        var eles = selector;
	        if (isString(selector)) {
	            var ctx = (isCash(context) ? context[0] : context) || doc;
	            eles = idRe.test(selector) && 'getElementById' in ctx
	                ? ctx.getElementById(selector.slice(1).replace(/\\/g, ''))
	                : htmlRe.test(selector)
	                    ? parseHTML(selector)
	                    : find(selector, ctx);
	            if (!eles)
	                return;
	        }
	        else if (isFunction(selector)) {
	            return this.ready(selector); //FIXME: `fn.ready` is not included in `core`, but it's actually a core functionality
	        }
	        if (eles.nodeType || eles === win)
	            eles = [eles];
	        this.length = eles.length;
	        for (var i = 0, l = this.length; i < l; i++) {
	            this[i] = eles[i];
	        }
	    }
	    Cash.prototype.init = function (selector, context) {
	        return new Cash(selector, context);
	    };
	    return Cash;
	}());
	var fn = Cash.prototype;
	var cash = fn.init;
	cash.fn = cash.prototype = fn; // Ensuring that `cash () instanceof cash`
	fn.length = 0;
	fn.splice = splice; // Ensuring a cash collection gets printed as array-like in Chrome's devtools
	if (typeof Symbol === 'function') { // Ensuring a cash collection is iterable
	    fn[Symbol['iterator']] = ArrayPrototype[Symbol['iterator']];
	}
	function isCash(value) {
	    return value instanceof Cash;
	}
	function isWindow(value) {
	    return !!value && value === value.window;
	}
	function isDocument(value) {
	    return !!value && value.nodeType === 9;
	}
	function isDocumentFragment(value) {
	    return !!value && value.nodeType === 11;
	}
	function isElement(value) {
	    return !!value && value.nodeType === 1;
	}
	function isText(value) {
	    return !!value && value.nodeType === 3;
	}
	function isBoolean(value) {
	    return typeof value === 'boolean';
	}
	function isFunction(value) {
	    return typeof value === 'function';
	}
	function isString(value) {
	    return typeof value === 'string';
	}
	function isUndefined(value) {
	    return value === undefined;
	}
	function isNull(value) {
	    return value === null;
	}
	function isNumeric(value) {
	    return !isNaN(parseFloat(value)) && isFinite(value);
	}
	function isPlainObject(value) {
	    if (typeof value !== 'object' || value === null)
	        return false;
	    var proto = Object.getPrototypeOf(value);
	    return proto === null || proto === Object.prototype;
	}
	cash.isWindow = isWindow;
	cash.isFunction = isFunction;
	cash.isArray = isArray;
	cash.isNumeric = isNumeric;
	cash.isPlainObject = isPlainObject;
	function each(arr, callback, _reverse) {
	    if (_reverse) {
	        var i = arr.length;
	        while (i--) {
	            if (callback.call(arr[i], i, arr[i]) === false)
	                return arr;
	        }
	    }
	    else if (isPlainObject(arr)) {
	        var keys = Object.keys(arr);
	        for (var i = 0, l = keys.length; i < l; i++) {
	            var key = keys[i];
	            if (callback.call(arr[key], key, arr[key]) === false)
	                return arr;
	        }
	    }
	    else {
	        for (var i = 0, l = arr.length; i < l; i++) {
	            if (callback.call(arr[i], i, arr[i]) === false)
	                return arr;
	        }
	    }
	    return arr;
	}
	cash.each = each;
	fn.each = function (callback) {
	    return each(this, callback);
	};
	fn.empty = function () {
	    return this.each(function (i, ele) {
	        while (ele.firstChild) {
	            ele.removeChild(ele.firstChild);
	        }
	    });
	};
	function extend() {
	    var sources = [];
	    for (var _i = 0; _i < arguments.length; _i++) {
	        sources[_i] = arguments[_i];
	    }
	    var deep = isBoolean(sources[0]) ? sources.shift() : false;
	    var target = sources.shift();
	    var length = sources.length;
	    if (!target)
	        return {};
	    if (!length)
	        return extend(deep, cash, target);
	    for (var i = 0; i < length; i++) {
	        var source = sources[i];
	        for (var key in source) {
	            if (deep && (isArray(source[key]) || isPlainObject(source[key]))) {
	                if (!target[key] || target[key].constructor !== source[key].constructor)
	                    target[key] = new source[key].constructor();
	                extend(deep, target[key], source[key]);
	            }
	            else {
	                target[key] = source[key];
	            }
	        }
	    }
	    return target;
	}
	cash.extend = extend;
	fn.extend = function (plugins) {
	    return extend(fn, plugins);
	};
	// @require ./type_checking.ts
	var splitValuesRe = /\S+/g;
	function getSplitValues(str) {
	    return isString(str) ? str.match(splitValuesRe) || [] : [];
	}
	fn.toggleClass = function (cls, force) {
	    var classes = getSplitValues(cls);
	    var isForce = !isUndefined(force);
	    return this.each(function (i, ele) {
	        if (!isElement(ele))
	            return;
	        each(classes, function (i, c) {
	            if (isForce) {
	                force ? ele.classList.add(c) : ele.classList.remove(c);
	            }
	            else {
	                ele.classList.toggle(c);
	            }
	        });
	    });
	};
	fn.addClass = function (cls) {
	    return this.toggleClass(cls, true);
	};
	fn.removeAttr = function (attr) {
	    var attrs = getSplitValues(attr);
	    return this.each(function (i, ele) {
	        if (!isElement(ele))
	            return;
	        each(attrs, function (i, a) {
	            ele.removeAttribute(a);
	        });
	    });
	};
	function attr(attr, value) {
	    if (!attr)
	        return;
	    if (isString(attr)) {
	        if (arguments.length < 2) {
	            if (!this[0] || !isElement(this[0]))
	                return;
	            var value_1 = this[0].getAttribute(attr);
	            return isNull(value_1) ? undefined : value_1;
	        }
	        if (isUndefined(value))
	            return this;
	        if (isNull(value))
	            return this.removeAttr(attr);
	        return this.each(function (i, ele) {
	            if (!isElement(ele))
	                return;
	            ele.setAttribute(attr, value);
	        });
	    }
	    for (var key in attr) {
	        this.attr(key, attr[key]);
	    }
	    return this;
	}
	fn.attr = attr;
	fn.removeClass = function (cls) {
	    if (arguments.length)
	        return this.toggleClass(cls, false);
	    return this.attr('class', '');
	};
	fn.hasClass = function (cls) {
	    return !!cls && some.call(this, function (ele) { return isElement(ele) && ele.classList.contains(cls); });
	};
	fn.get = function (index) {
	    if (isUndefined(index))
	        return slice.call(this);
	    index = Number(index);
	    return this[index < 0 ? index + this.length : index];
	};
	fn.eq = function (index) {
	    return cash(this.get(index));
	};
	fn.first = function () {
	    return this.eq(0);
	};
	fn.last = function () {
	    return this.eq(-1);
	};
	function text(text) {
	    if (isUndefined(text)) {
	        return this.get().map(function (ele) { return isElement(ele) || isText(ele) ? ele.textContent : ''; }).join('');
	    }
	    return this.each(function (i, ele) {
	        if (!isElement(ele))
	            return;
	        ele.textContent = text;
	    });
	}
	fn.text = text;
	// @require core/type_checking.ts
	// @require core/variables.ts
	function computeStyle(ele, prop, isVariable) {
	    if (!isElement(ele))
	        return;
	    var style = win.getComputedStyle(ele, null);
	    return isVariable ? style.getPropertyValue(prop) || undefined : style[prop] || ele.style[prop];
	}
	// @require ./compute_style.ts
	function computeStyleInt(ele, prop) {
	    return parseInt(computeStyle(ele, prop), 10) || 0;
	}
	// @require css/helpers/compute_style_int.ts
	function getExtraSpace(ele, xAxis) {
	    return computeStyleInt(ele, "border".concat(xAxis ? 'Left' : 'Top', "Width")) + computeStyleInt(ele, "padding".concat(xAxis ? 'Left' : 'Top')) + computeStyleInt(ele, "padding".concat(xAxis ? 'Right' : 'Bottom')) + computeStyleInt(ele, "border".concat(xAxis ? 'Right' : 'Bottom', "Width"));
	}
	// @require css/helpers/compute_style.ts
	var defaultDisplay = {};
	function getDefaultDisplay(tagName) {
	    if (defaultDisplay[tagName])
	        return defaultDisplay[tagName];
	    var ele = createElement(tagName);
	    doc.body.insertBefore(ele, null);
	    var display = computeStyle(ele, 'display');
	    doc.body.removeChild(ele);
	    return defaultDisplay[tagName] = display !== 'none' ? display : 'block';
	}
	// @require css/helpers/compute_style.ts
	function isHidden(ele) {
	    return computeStyle(ele, 'display') === 'none';
	}
	// @require ./cash.ts
	function matches(ele, selector) {
	    var matches = ele && (ele['matches'] || ele['webkitMatchesSelector'] || ele['msMatchesSelector']);
	    return !!matches && !!selector && matches.call(ele, selector);
	}
	// @require ./matches.ts
	// @require ./type_checking.ts
	function getCompareFunction(comparator) {
	    return isString(comparator)
	        ? function (i, ele) { return matches(ele, comparator); }
	        : isFunction(comparator)
	            ? comparator
	            : isCash(comparator)
	                ? function (i, ele) { return comparator.is(ele); }
	                : !comparator
	                    ? function () { return false; }
	                    : function (i, ele) { return ele === comparator; };
	}
	fn.filter = function (comparator) {
	    var compare = getCompareFunction(comparator);
	    return cash(filter.call(this, function (ele, i) { return compare.call(ele, i, ele); }));
	};
	// @require collection/filter.ts
	function filtered(collection, comparator) {
	    return !comparator ? collection : collection.filter(comparator);
	}
	fn.detach = function (comparator) {
	    filtered(this, comparator).each(function (i, ele) {
	        if (ele.parentNode) {
	            ele.parentNode.removeChild(ele);
	        }
	    });
	    return this;
	};
	var fragmentRe = /^\s*<(\w+)[^>]*>/;
	var singleTagRe = /^<(\w+)\s*\/?>(?:<\/\1>)?$/;
	var containers = {
	    '*': div,
	    tr: tbody,
	    td: tr,
	    th: tr,
	    thead: table,
	    tbody: table,
	    tfoot: table
	};
	//TODO: Create elements inside a document fragment, in order to prevent inline event handlers from firing
	//TODO: Ensure the created elements have the fragment as their parent instead of null, this also ensures we can deal with detatched nodes more reliably
	function parseHTML(html) {
	    if (!isString(html))
	        return [];
	    if (singleTagRe.test(html))
	        return [createElement(RegExp.$1)];
	    var fragment = fragmentRe.test(html) && RegExp.$1;
	    var container = containers[fragment] || containers['*'];
	    container.innerHTML = html;
	    return cash(container.childNodes).detach().get();
	}
	cash.parseHTML = parseHTML;
	fn.has = function (selector) {
	    var comparator = isString(selector)
	        ? function (i, ele) { return find(selector, ele).length; }
	        : function (i, ele) { return ele.contains(selector); };
	    return this.filter(comparator);
	};
	fn.not = function (comparator) {
	    var compare = getCompareFunction(comparator);
	    return this.filter(function (i, ele) { return (!isString(comparator) || isElement(ele)) && !compare.call(ele, i, ele); });
	};
	function pluck(arr, prop, deep, until) {
	    var plucked = [];
	    var isCallback = isFunction(prop);
	    var compare = until && getCompareFunction(until);
	    for (var i = 0, l = arr.length; i < l; i++) {
	        if (isCallback) {
	            var val_1 = prop(arr[i]);
	            if (val_1.length)
	                push.apply(plucked, val_1);
	        }
	        else {
	            var val_2 = arr[i][prop];
	            while (val_2 != null) {
	                if (until && compare(-1, val_2))
	                    break;
	                plucked.push(val_2);
	                val_2 = deep ? val_2[prop] : null;
	            }
	        }
	    }
	    return plucked;
	}
	// @require core/pluck.ts
	// @require core/variables.ts
	function getValue(ele) {
	    if (ele.multiple && ele.options)
	        return pluck(filter.call(ele.options, function (option) { return option.selected && !option.disabled && !option.parentNode.disabled; }), 'value');
	    return ele.value || '';
	}
	function val(value) {
	    if (!arguments.length)
	        return this[0] && getValue(this[0]);
	    return this.each(function (i, ele) {
	        var isSelect = ele.multiple && ele.options;
	        if (isSelect || checkableRe.test(ele.type)) {
	            var eleValue_1 = isArray(value) ? map.call(value, String) : (isNull(value) ? [] : [String(value)]);
	            if (isSelect) {
	                each(ele.options, function (i, option) {
	                    option.selected = eleValue_1.indexOf(option.value) >= 0;
	                }, true);
	            }
	            else {
	                ele.checked = eleValue_1.indexOf(ele.value) >= 0;
	            }
	        }
	        else {
	            ele.value = isUndefined(value) || isNull(value) ? '' : value;
	        }
	    });
	}
	fn.val = val;
	fn.is = function (comparator) {
	    var compare = getCompareFunction(comparator);
	    return some.call(this, function (ele, i) { return compare.call(ele, i, ele); });
	};
	cash.guid = 1;
	function unique(arr) {
	    return arr.length > 1 ? filter.call(arr, function (item, index, self) { return indexOf.call(self, item) === index; }) : arr;
	}
	cash.unique = unique;
	fn.add = function (selector, context) {
	    return cash(unique(this.get().concat(cash(selector, context).get())));
	};
	fn.children = function (comparator) {
	    return filtered(cash(unique(pluck(this, function (ele) { return ele.children; }))), comparator);
	};
	fn.parent = function (comparator) {
	    return filtered(cash(unique(pluck(this, 'parentNode'))), comparator);
	};
	fn.index = function (selector) {
	    var child = selector ? cash(selector)[0] : this[0];
	    var collection = selector ? this : cash(child).parent().children();
	    return indexOf.call(collection, child);
	};
	fn.closest = function (comparator) {
	    var filtered = this.filter(comparator);
	    if (filtered.length)
	        return filtered;
	    var $parent = this.parent();
	    if (!$parent.length)
	        return filtered;
	    return $parent.closest(comparator);
	};
	fn.siblings = function (comparator) {
	    return filtered(cash(unique(pluck(this, function (ele) { return cash(ele).parent().children().not(ele); }))), comparator);
	};
	fn.find = function (selector) {
	    return cash(unique(pluck(this, function (ele) { return find(selector, ele); })));
	};
	// @require core/variables.ts
	// @require collection/filter.ts
	// @require traversal/find.ts
	var HTMLCDATARe = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	var scriptTypeRe = /^$|^module$|\/(java|ecma)script/i;
	var scriptAttributes = ['type', 'src', 'nonce', 'noModule'];
	function evalScripts(node, doc) {
	    var collection = cash(node);
	    collection.filter('script').add(collection.find('script')).each(function (i, ele) {
	        if (scriptTypeRe.test(ele.type) && docEle.contains(ele)) { // The script type is supported // The element is attached to the DOM // Using `documentElement` for broader browser support
	            var script_1 = createElement('script');
	            script_1.text = ele.textContent.replace(HTMLCDATARe, '');
	            each(scriptAttributes, function (i, attr) {
	                if (ele[attr])
	                    script_1[attr] = ele[attr];
	            });
	            doc.head.insertBefore(script_1, null);
	            doc.head.removeChild(script_1);
	        }
	    });
	}
	// @require ./eval_scripts.ts
	function insertElement(anchor, target, left, inside, evaluate) {
	    if (inside) { // prepend/append
	        anchor.insertBefore(target, left ? anchor.firstChild : null);
	    }
	    else { // before/after
	        if (anchor.nodeName === 'HTML') {
	            anchor.parentNode.replaceChild(target, anchor);
	        }
	        else {
	            anchor.parentNode.insertBefore(target, left ? anchor : anchor.nextSibling);
	        }
	    }
	    if (evaluate) {
	        evalScripts(target, anchor.ownerDocument);
	    }
	}
	// @require ./insert_element.ts
	function insertSelectors(selectors, anchors, inverse, left, inside, reverseLoop1, reverseLoop2, reverseLoop3) {
	    each(selectors, function (si, selector) {
	        each(cash(selector), function (ti, target) {
	            each(cash(anchors), function (ai, anchor) {
	                var anchorFinal = inverse ? target : anchor;
	                var targetFinal = inverse ? anchor : target;
	                var indexFinal = inverse ? ti : ai;
	                insertElement(anchorFinal, !indexFinal ? targetFinal : targetFinal.cloneNode(true), left, inside, !indexFinal);
	            }, reverseLoop3);
	        }, reverseLoop2);
	    }, reverseLoop1);
	    return anchors;
	}
	fn.after = function () {
	    return insertSelectors(arguments, this, false, false, false, true, true);
	};
	fn.append = function () {
	    return insertSelectors(arguments, this, false, false, true);
	};
	function html(html) {
	    if (!arguments.length)
	        return this[0] && this[0].innerHTML;
	    if (isUndefined(html))
	        return this;
	    var hasScript = /<script[\s>]/.test(html);
	    return this.each(function (i, ele) {
	        if (!isElement(ele))
	            return;
	        if (hasScript) {
	            cash(ele).empty().append(html);
	        }
	        else {
	            ele.innerHTML = html;
	        }
	    });
	}
	fn.html = html;
	fn.appendTo = function (selector) {
	    return insertSelectors(arguments, this, true, false, true);
	};
	fn.wrapInner = function (selector) {
	    return this.each(function (i, ele) {
	        var $ele = cash(ele);
	        var contents = $ele.contents();
	        contents.length ? contents.wrapAll(selector) : $ele.append(selector);
	    });
	};
	fn.before = function () {
	    return insertSelectors(arguments, this, false, true);
	};
	fn.wrapAll = function (selector) {
	    var structure = cash(selector);
	    var wrapper = structure[0];
	    while (wrapper.children.length)
	        wrapper = wrapper.firstElementChild;
	    this.first().before(structure);
	    return this.appendTo(wrapper);
	};
	fn.wrap = function (selector) {
	    return this.each(function (i, ele) {
	        var wrapper = cash(selector)[0];
	        cash(ele).wrapAll(!i ? wrapper : wrapper.cloneNode(true));
	    });
	};
	fn.insertAfter = function (selector) {
	    return insertSelectors(arguments, this, true, false, false, false, false, true);
	};
	fn.insertBefore = function (selector) {
	    return insertSelectors(arguments, this, true, true);
	};
	fn.prepend = function () {
	    return insertSelectors(arguments, this, false, true, true, true, true);
	};
	fn.prependTo = function (selector) {
	    return insertSelectors(arguments, this, true, true, true, false, false, true);
	};
	fn.contents = function () {
	    return cash(unique(pluck(this, function (ele) { return ele.tagName === 'IFRAME' ? [ele.contentDocument] : (ele.tagName === 'TEMPLATE' ? ele.content.childNodes : ele.childNodes); })));
	};
	fn.next = function (comparator, _all, _until) {
	    return filtered(cash(unique(pluck(this, 'nextElementSibling', _all, _until))), comparator);
	};
	fn.nextAll = function (comparator) {
	    return this.next(comparator, true);
	};
	fn.nextUntil = function (until, comparator) {
	    return this.next(comparator, true, until);
	};
	fn.parents = function (comparator, _until) {
	    return filtered(cash(unique(pluck(this, 'parentElement', true, _until))), comparator);
	};
	fn.parentsUntil = function (until, comparator) {
	    return this.parents(comparator, until);
	};
	fn.prev = function (comparator, _all, _until) {
	    return filtered(cash(unique(pluck(this, 'previousElementSibling', _all, _until))), comparator);
	};
	fn.prevAll = function (comparator) {
	    return this.prev(comparator, true);
	};
	fn.prevUntil = function (until, comparator) {
	    return this.prev(comparator, true, until);
	};
	fn.map = function (callback) {
	    return cash(concat.apply([], map.call(this, function (ele, i) { return callback.call(ele, i, ele); })));
	};
	fn.clone = function () {
	    return this.map(function (i, ele) { return ele.cloneNode(true); });
	};
	fn.offsetParent = function () {
	    return this.map(function (i, ele) {
	        var offsetParent = ele.offsetParent;
	        while (offsetParent && computeStyle(offsetParent, 'position') === 'static') {
	            offsetParent = offsetParent.offsetParent;
	        }
	        return offsetParent || docEle;
	    });
	};
	fn.slice = function (start, end) {
	    return cash(slice.call(this, start, end));
	};
	// @require ./cash.ts
	var dashAlphaRe = /-([a-z])/g;
	function camelCase(str) {
	    return str.replace(dashAlphaRe, function (match, letter) { return letter.toUpperCase(); });
	}
	fn.ready = function (callback) {
	    var cb = function () { return setTimeout(callback, 0, cash); };
	    if (doc.readyState !== 'loading') {
	        cb();
	    }
	    else {
	        doc.addEventListener('DOMContentLoaded', cb);
	    }
	    return this;
	};
	fn.unwrap = function () {
	    this.parent().each(function (i, ele) {
	        if (ele.tagName === 'BODY')
	            return;
	        var $ele = cash(ele);
	        $ele.replaceWith($ele.children());
	    });
	    return this;
	};
	fn.offset = function () {
	    var ele = this[0];
	    if (!ele)
	        return;
	    var rect = ele.getBoundingClientRect();
	    return {
	        top: rect.top + win.pageYOffset,
	        left: rect.left + win.pageXOffset
	    };
	};
	fn.position = function () {
	    var ele = this[0];
	    if (!ele)
	        return;
	    var isFixed = (computeStyle(ele, 'position') === 'fixed');
	    var offset = isFixed ? ele.getBoundingClientRect() : this.offset();
	    if (!isFixed) {
	        var doc_1 = ele.ownerDocument;
	        var offsetParent = ele.offsetParent || doc_1.documentElement;
	        while ((offsetParent === doc_1.body || offsetParent === doc_1.documentElement) && computeStyle(offsetParent, 'position') === 'static') {
	            offsetParent = offsetParent.parentNode;
	        }
	        if (offsetParent !== ele && isElement(offsetParent)) {
	            var parentOffset = cash(offsetParent).offset();
	            offset.top -= parentOffset.top + computeStyleInt(offsetParent, 'borderTopWidth');
	            offset.left -= parentOffset.left + computeStyleInt(offsetParent, 'borderLeftWidth');
	        }
	    }
	    return {
	        top: offset.top - computeStyleInt(ele, 'marginTop'),
	        left: offset.left - computeStyleInt(ele, 'marginLeft')
	    };
	};
	var propMap = {
	    /* GENERAL */
	    class: 'className',
	    contenteditable: 'contentEditable',
	    /* LABEL */
	    for: 'htmlFor',
	    /* INPUT */
	    readonly: 'readOnly',
	    maxlength: 'maxLength',
	    tabindex: 'tabIndex',
	    /* TABLE */
	    colspan: 'colSpan',
	    rowspan: 'rowSpan',
	    /* IMAGE */
	    usemap: 'useMap'
	};
	fn.prop = function (prop, value) {
	    if (!prop)
	        return;
	    if (isString(prop)) {
	        prop = propMap[prop] || prop;
	        if (arguments.length < 2)
	            return this[0] && this[0][prop];
	        return this.each(function (i, ele) { ele[prop] = value; });
	    }
	    for (var key in prop) {
	        this.prop(key, prop[key]);
	    }
	    return this;
	};
	fn.removeProp = function (prop) {
	    return this.each(function (i, ele) { delete ele[propMap[prop] || prop]; });
	};
	var cssVariableRe = /^--/;
	// @require ./variables.ts
	function isCSSVariable(prop) {
	    return cssVariableRe.test(prop);
	}
	// @require core/camel_case.ts
	// @require core/cash.ts
	// @require core/each.ts
	// @require core/variables.ts
	// @require ./is_css_variable.ts
	var prefixedProps = {};
	var style = div.style;
	var vendorsPrefixes = ['webkit', 'moz', 'ms'];
	function getPrefixedProp(prop, isVariable) {
	    if (isVariable === void 0) { isVariable = isCSSVariable(prop); }
	    if (isVariable)
	        return prop;
	    if (!prefixedProps[prop]) {
	        var propCC = camelCase(prop);
	        var propUC = "".concat(propCC[0].toUpperCase()).concat(propCC.slice(1));
	        var props = ("".concat(propCC, " ").concat(vendorsPrefixes.join("".concat(propUC, " "))).concat(propUC)).split(' ');
	        each(props, function (i, p) {
	            if (p in style) {
	                prefixedProps[prop] = p;
	                return false;
	            }
	        });
	    }
	    return prefixedProps[prop];
	}
	// @require core/type_checking.ts
	// @require ./is_css_variable.ts
	var numericProps = {
	    animationIterationCount: true,
	    columnCount: true,
	    flexGrow: true,
	    flexShrink: true,
	    fontWeight: true,
	    gridArea: true,
	    gridColumn: true,
	    gridColumnEnd: true,
	    gridColumnStart: true,
	    gridRow: true,
	    gridRowEnd: true,
	    gridRowStart: true,
	    lineHeight: true,
	    opacity: true,
	    order: true,
	    orphans: true,
	    widows: true,
	    zIndex: true
	};
	function getSuffixedValue(prop, value, isVariable) {
	    if (isVariable === void 0) { isVariable = isCSSVariable(prop); }
	    return !isVariable && !numericProps[prop] && isNumeric(value) ? "".concat(value, "px") : value;
	}
	function css(prop, value) {
	    if (isString(prop)) {
	        var isVariable_1 = isCSSVariable(prop);
	        prop = getPrefixedProp(prop, isVariable_1);
	        if (arguments.length < 2)
	            return this[0] && computeStyle(this[0], prop, isVariable_1);
	        if (!prop)
	            return this;
	        value = getSuffixedValue(prop, value, isVariable_1);
	        return this.each(function (i, ele) {
	            if (!isElement(ele))
	                return;
	            if (isVariable_1) {
	                ele.style.setProperty(prop, value);
	            }
	            else {
	                ele.style[prop] = value;
	            }
	        });
	    }
	    for (var key in prop) {
	        this.css(key, prop[key]);
	    }
	    return this;
	}
	fn.css = css;
	function attempt(fn, arg) {
	    try {
	        return fn(arg);
	    }
	    catch (_a) {
	        return arg;
	    }
	}
	// @require core/attempt.ts
	// @require core/camel_case.ts
	var JSONStringRe = /^\s+|\s+$/;
	function getData(ele, key) {
	    var value = ele.dataset[key] || ele.dataset[camelCase(key)];
	    if (JSONStringRe.test(value))
	        return value;
	    return attempt(JSON.parse, value);
	}
	// @require core/attempt.ts
	// @require core/camel_case.ts
	function setData(ele, key, value) {
	    value = attempt(JSON.stringify, value);
	    ele.dataset[camelCase(key)] = value;
	}
	function data(name, value) {
	    if (!name) {
	        if (!this[0])
	            return;
	        var datas = {};
	        for (var key in this[0].dataset) {
	            datas[key] = getData(this[0], key);
	        }
	        return datas;
	    }
	    if (isString(name)) {
	        if (arguments.length < 2)
	            return this[0] && getData(this[0], name);
	        if (isUndefined(value))
	            return this;
	        return this.each(function (i, ele) { setData(ele, name, value); });
	    }
	    for (var key in name) {
	        this.data(key, name[key]);
	    }
	    return this;
	}
	fn.data = data;
	function getDocumentDimension(doc, dimension) {
	    var docEle = doc.documentElement;
	    return Math.max(doc.body["scroll".concat(dimension)], docEle["scroll".concat(dimension)], doc.body["offset".concat(dimension)], docEle["offset".concat(dimension)], docEle["client".concat(dimension)]);
	}
	each([true, false], function (i, outer) {
	    each(['Width', 'Height'], function (i, prop) {
	        var name = "".concat(outer ? 'outer' : 'inner').concat(prop);
	        fn[name] = function (includeMargins) {
	            if (!this[0])
	                return;
	            if (isWindow(this[0]))
	                return outer ? this[0]["inner".concat(prop)] : this[0].document.documentElement["client".concat(prop)];
	            if (isDocument(this[0]))
	                return getDocumentDimension(this[0], prop);
	            return this[0]["".concat(outer ? 'offset' : 'client').concat(prop)] + (includeMargins && outer ? computeStyleInt(this[0], "margin".concat(i ? 'Top' : 'Left')) + computeStyleInt(this[0], "margin".concat(i ? 'Bottom' : 'Right')) : 0);
	        };
	    });
	});
	each(['Width', 'Height'], function (index, prop) {
	    var propLC = prop.toLowerCase();
	    fn[propLC] = function (value) {
	        if (!this[0])
	            return isUndefined(value) ? undefined : this;
	        if (!arguments.length) {
	            if (isWindow(this[0]))
	                return this[0].document.documentElement["client".concat(prop)];
	            if (isDocument(this[0]))
	                return getDocumentDimension(this[0], prop);
	            return this[0].getBoundingClientRect()[propLC] - getExtraSpace(this[0], !index);
	        }
	        var valueNumber = parseInt(value, 10);
	        return this.each(function (i, ele) {
	            if (!isElement(ele))
	                return;
	            var boxSizing = computeStyle(ele, 'boxSizing');
	            ele.style[propLC] = getSuffixedValue(propLC, valueNumber + (boxSizing === 'border-box' ? getExtraSpace(ele, !index) : 0));
	        });
	    };
	});
	var displayProperty = '___cd';
	fn.toggle = function (force) {
	    return this.each(function (i, ele) {
	        if (!isElement(ele))
	            return;
	        var show = isUndefined(force) ? isHidden(ele) : force;
	        if (show) {
	            ele.style.display = ele[displayProperty] || '';
	            if (isHidden(ele)) {
	                ele.style.display = getDefaultDisplay(ele.tagName);
	            }
	        }
	        else {
	            ele[displayProperty] = computeStyle(ele, 'display');
	            ele.style.display = 'none';
	        }
	    });
	};
	fn.hide = function () {
	    return this.toggle(false);
	};
	fn.show = function () {
	    return this.toggle(true);
	};
	var eventsNamespace = '___ce';
	var eventsNamespacesSeparator = '.';
	var eventsFocus = { focus: 'focusin', blur: 'focusout' };
	var eventsHover = { mouseenter: 'mouseover', mouseleave: 'mouseout' };
	var eventsMouseRe = /^(mouse|pointer|contextmenu|drag|drop|click|dblclick)/i;
	// @require ./variables.ts
	function getEventNameBubbling(name) {
	    return eventsHover[name] || eventsFocus[name] || name;
	}
	// @require ./variables.ts
	function parseEventName(eventName) {
	    var parts = eventName.split(eventsNamespacesSeparator);
	    return [parts[0], parts.slice(1).sort()]; // [name, namespace[]]
	}
	fn.trigger = function (event, data) {
	    if (isString(event)) {
	        var _a = parseEventName(event), nameOriginal = _a[0], namespaces = _a[1];
	        var name_1 = getEventNameBubbling(nameOriginal);
	        if (!name_1)
	            return this;
	        var type = eventsMouseRe.test(name_1) ? 'MouseEvents' : 'HTMLEvents';
	        event = doc.createEvent(type);
	        event.initEvent(name_1, true, true);
	        event.namespace = namespaces.join(eventsNamespacesSeparator);
	        event.___ot = nameOriginal;
	    }
	    event.___td = data;
	    var isEventFocus = (event.___ot in eventsFocus);
	    return this.each(function (i, ele) {
	        if (isEventFocus && isFunction(ele[event.___ot])) {
	            ele["___i".concat(event.type)] = true; // Ensuring the native event is ignored
	            ele[event.___ot]();
	            ele["___i".concat(event.type)] = false; // Ensuring the custom event is not ignored
	        }
	        ele.dispatchEvent(event);
	    });
	};
	// @require ./variables.ts
	function getEventsCache(ele) {
	    return ele[eventsNamespace] = (ele[eventsNamespace] || {});
	}
	// @require core/guid.ts
	// @require events/helpers/get_events_cache.ts
	function addEvent(ele, name, namespaces, selector, callback) {
	    var eventCache = getEventsCache(ele);
	    eventCache[name] = (eventCache[name] || []);
	    eventCache[name].push([namespaces, selector, callback]);
	    ele.addEventListener(name, callback);
	}
	function hasNamespaces(ns1, ns2) {
	    return !ns2 || !some.call(ns2, function (ns) { return ns1.indexOf(ns) < 0; });
	}
	// @require ./get_events_cache.ts
	// @require ./has_namespaces.ts
	// @require ./parse_event_name.ts
	function removeEvent(ele, name, namespaces, selector, callback) {
	    var cache = getEventsCache(ele);
	    if (!name) {
	        for (name in cache) {
	            removeEvent(ele, name, namespaces, selector, callback);
	        }
	    }
	    else if (cache[name]) {
	        cache[name] = cache[name].filter(function (_a) {
	            var ns = _a[0], sel = _a[1], cb = _a[2];
	            if ((callback && cb.guid !== callback.guid) || !hasNamespaces(ns, namespaces) || (selector && selector !== sel))
	                return true;
	            ele.removeEventListener(name, cb);
	        });
	    }
	}
	fn.off = function (eventFullName, selector, callback) {
	    var _this = this;
	    if (isUndefined(eventFullName)) {
	        this.each(function (i, ele) {
	            if (!isElement(ele) && !isDocument(ele) && !isWindow(ele))
	                return;
	            removeEvent(ele);
	        });
	    }
	    else if (!isString(eventFullName)) {
	        for (var key in eventFullName) {
	            this.off(key, eventFullName[key]);
	        }
	    }
	    else {
	        if (isFunction(selector)) {
	            callback = selector;
	            selector = '';
	        }
	        each(getSplitValues(eventFullName), function (i, eventFullName) {
	            var _a = parseEventName(eventFullName), nameOriginal = _a[0], namespaces = _a[1];
	            var name = getEventNameBubbling(nameOriginal);
	            _this.each(function (i, ele) {
	                if (!isElement(ele) && !isDocument(ele) && !isWindow(ele))
	                    return;
	                removeEvent(ele, name, namespaces, selector, callback);
	            });
	        });
	    }
	    return this;
	};
	fn.remove = function (comparator) {
	    filtered(this, comparator).detach().off();
	    return this;
	};
	fn.replaceWith = function (selector) {
	    return this.before(selector).remove();
	};
	fn.replaceAll = function (selector) {
	    cash(selector).replaceWith(this);
	    return this;
	};
	function on(eventFullName, selector, data, callback, _one) {
	    var _this = this;
	    if (!isString(eventFullName)) {
	        for (var key in eventFullName) {
	            this.on(key, selector, data, eventFullName[key], _one);
	        }
	        return this;
	    }
	    if (!isString(selector)) {
	        if (isUndefined(selector) || isNull(selector)) {
	            selector = '';
	        }
	        else if (isUndefined(data)) {
	            data = selector;
	            selector = '';
	        }
	        else {
	            callback = data;
	            data = selector;
	            selector = '';
	        }
	    }
	    if (!isFunction(callback)) {
	        callback = data;
	        data = undefined;
	    }
	    if (!callback)
	        return this;
	    each(getSplitValues(eventFullName), function (i, eventFullName) {
	        var _a = parseEventName(eventFullName), nameOriginal = _a[0], namespaces = _a[1];
	        var name = getEventNameBubbling(nameOriginal);
	        var isEventHover = (nameOriginal in eventsHover);
	        var isEventFocus = (nameOriginal in eventsFocus);
	        if (!name)
	            return;
	        _this.each(function (i, ele) {
	            if (!isElement(ele) && !isDocument(ele) && !isWindow(ele))
	                return;
	            var finalCallback = function (event) {
	                if (event.target["___i".concat(event.type)])
	                    return event.stopImmediatePropagation(); // Ignoring native event in favor of the upcoming custom one
	                if (event.namespace && !hasNamespaces(namespaces, event.namespace.split(eventsNamespacesSeparator)))
	                    return;
	                if (!selector && ((isEventFocus && (event.target !== ele || event.___ot === name)) || (isEventHover && event.relatedTarget && ele.contains(event.relatedTarget))))
	                    return;
	                var thisArg = ele;
	                if (selector) {
	                    var target = event.target;
	                    while (!matches(target, selector)) {
	                        if (target === ele)
	                            return;
	                        target = target.parentNode;
	                        if (!target)
	                            return;
	                    }
	                    thisArg = target;
	                }
	                Object.defineProperty(event, 'currentTarget', {
	                    configurable: true,
	                    get: function () {
	                        return thisArg;
	                    }
	                });
	                Object.defineProperty(event, 'delegateTarget', {
	                    configurable: true,
	                    get: function () {
	                        return ele;
	                    }
	                });
	                Object.defineProperty(event, 'data', {
	                    configurable: true,
	                    get: function () {
	                        return data;
	                    }
	                });
	                var returnValue = callback.call(thisArg, event, event.___td);
	                if (_one) {
	                    removeEvent(ele, name, namespaces, selector, finalCallback);
	                }
	                if (returnValue === false) {
	                    event.preventDefault();
	                    event.stopPropagation();
	                }
	            };
	            finalCallback.guid = callback.guid = (callback.guid || cash.guid++);
	            addEvent(ele, name, namespaces, selector, finalCallback);
	        });
	    });
	    return this;
	}
	fn.on = on;
	function one(eventFullName, selector, data, callback) {
	    return this.on(eventFullName, selector, data, callback, true);
	}
	fn.one = one;
	var queryEncodeSpaceRe = /%20/g;
	var queryEncodeCRLFRe = /\r?\n/g;
	function queryEncode(prop, value) {
	    return "&".concat(encodeURIComponent(prop), "=").concat(encodeURIComponent(value.replace(queryEncodeCRLFRe, '\r\n')).replace(queryEncodeSpaceRe, '+'));
	}
	var skippableRe = /file|reset|submit|button|image/i;
	var checkableRe = /radio|checkbox/i;
	fn.serialize = function () {
	    var query = '';
	    this.each(function (i, ele) {
	        each(ele.elements || [ele], function (i, ele) {
	            if (ele.disabled || !ele.name || ele.tagName === 'FIELDSET' || skippableRe.test(ele.type) || (checkableRe.test(ele.type) && !ele.checked))
	                return;
	            var value = getValue(ele);
	            if (!isUndefined(value)) {
	                var values = isArray(value) ? value : [value];
	                each(values, function (i, value) {
	                    query += queryEncode(ele.name, value);
	                });
	            }
	        });
	    });
	    return query.slice(1);
	};
	// @require core/types.ts
	// @require core/cash.ts
	// @require core/type_checking.ts
	// @require core/variables.ts
	// @require core/each.ts
	// @require core/extend.ts
	// @require core/find.ts
	// @require core/get_compare_function.ts
	// @require core/get_split_values.ts
	// @require core/guid.ts
	// @require core/parse_html.ts
	// @require core/unique.ts
	// @require attributes/add_class.ts
	// @require attributes/attr.ts
	// @require attributes/has_class.ts
	// @require attributes/prop.ts
	// @require attributes/remove_attr.ts
	// @require attributes/remove_class.ts
	// @require attributes/remove_prop.ts
	// @require attributes/toggle_class.ts
	// @require collection/add.ts
	// @require collection/each.ts
	// @require collection/eq.ts
	// @require collection/filter.ts
	// @require collection/first.ts
	// @require collection/get.ts
	// @require collection/index.ts
	// @require collection/last.ts
	// @require collection/map.ts
	// @require collection/slice.ts
	// @require css/css.ts
	// @require data/data.ts
	// @require dimensions/inner_outer.ts
	// @require dimensions/normal.ts
	// @require effects/hide.ts
	// @require effects/show.ts
	// @require effects/toggle.ts
	// @require events/off.ts
	// @require events/on.ts
	// @require events/one.ts
	// @require events/ready.ts
	// @require events/trigger.ts
	// @require forms/serialize.ts
	// @require forms/val.ts
	// @require manipulation/after.ts
	// @require manipulation/append.ts
	// @require manipulation/append_to.ts
	// @require manipulation/before.ts
	// @require manipulation/clone.ts
	// @require manipulation/detach.ts
	// @require manipulation/empty.ts
	// @require manipulation/html.ts
	// @require manipulation/insert_after.ts
	// @require manipulation/insert_before.ts
	// @require manipulation/prepend.ts
	// @require manipulation/prepend_to.ts
	// @require manipulation/remove.ts
	// @require manipulation/replace_all.ts
	// @require manipulation/replace_with.ts
	// @require manipulation/text.ts
	// @require manipulation/unwrap.ts
	// @require manipulation/wrap.ts
	// @require manipulation/wrap_all.ts
	// @require manipulation/wrap_inner.ts
	// @require offset/offset.ts
	// @require offset/offset_parent.ts
	// @require offset/position.ts
	// @require traversal/children.ts
	// @require traversal/closest.ts
	// @require traversal/contents.ts
	// @require traversal/find.ts
	// @require traversal/has.ts
	// @require traversal/is.ts
	// @require traversal/next.ts
	// @require traversal/next_all.ts
	// @require traversal/next_until.ts
	// @require traversal/not.ts
	// @require traversal/parent.ts
	// @require traversal/parents.ts
	// @require traversal/parents_until.ts
	// @require traversal/prev.ts
	// @require traversal/prev_all.ts
	// @require traversal/prev_until.ts
	// @require traversal/siblings.ts
	// @no-require extras/get_script.ts
	// @no-require extras/shorthands.ts
	// @require methods.ts
	{ // Node.js
	    module.exports = cash;
	}
	})();
} (cash$1));

var cash = cash$1.exports;

const svgNS$1 = 'http://www.w3.org/2000/svg';
class CashDomWrapper {
    parse(content) {
        const createElement = (tagName) => {
            return cash(document.createElementNS(svgNS$1, tagName));
        };
        const div = document.createElement('div');
        div.id = 'transfo-dom-wrapper-main';
        div.innerHTML = content;
        const root = cash(div);
        return {
            $: cash,
            root,
            rootElement: root.children(),
            createElement
        };
    }
}

const svgNS = 'http://www.w3.org/2000/svg';
class InlineCashDomWrapper {
    constructor(element) {
        this.element = element;
        this.keepContent = true;
    }
    parse(content) {
        const createElement = (tagName) => {
            return cash(document.createElementNS(svgNS, tagName));
        };
        const root = cash(this.element);
        return {
            $: cash,
            root,
            rootElement: root.children(),
            createElement
        };
    }
}

class XhrDownloader {
    download(url) {
        return new Promise((res, rej) => {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        res(xhr.responseText);
                    }
                    else {
                        rej(xhr);
                    }
                }
            };
            xhr.open("GET", url);
            xhr.send();
        });
    }
}

// This file is autogenerated. It's used to publish ESM to npm.
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

var trimLeft = /^\s+/;
var trimRight = /\s+$/;
function tinycolor(color, opts) {
  color = color ? color : "";
  opts = opts || {};

  // If input is already a tinycolor, return itself
  if (color instanceof tinycolor) {
    return color;
  }
  // If we are called as a function, call using new instead
  if (!(this instanceof tinycolor)) {
    return new tinycolor(color, opts);
  }
  var rgb = inputToRGB(color);
  this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
  this._gradientType = opts.gradientType;

  // Don't let the range of [0,255] come back in [0,1].
  // Potentially lose a little bit of precision here, but will fix issues where
  // .5 gets interpreted as half of the total, instead of half of 1
  // If it was supposed to be 128, this was already taken care of by `inputToRgb`
  if (this._r < 1) this._r = Math.round(this._r);
  if (this._g < 1) this._g = Math.round(this._g);
  if (this._b < 1) this._b = Math.round(this._b);
  this._ok = rgb.ok;
}
tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    //http://www.w3.org/TR/AERT#color-contrast
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  },
  getLuminance: function getLuminance() {
    //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    var rgb = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B;
    RsRGB = rgb.r / 255;
    GsRGB = rgb.g / 255;
    BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  },
  setAlpha: function setAlpha(value) {
    this._a = boundAlpha(value);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360),
      s = Math.round(hsv.s * 100),
      v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl.h * 360,
      s: hsl.s,
      l: hsl.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl.h * 360),
      s = Math.round(hsl.s * 100),
      l = Math.round(hsl.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }
    if (this._a < 1) {
      return false;
    }
    return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";
    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString(format) {
    var formatSet = !!format;
    format = format || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
    if (needsAlphaFormat) {
      // Special case for "transparent", all other non-alpha formats
      // will return rgba when there is transparency.
      if (format === "name" && this._a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }
    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format === "name") {
      formattedString = this.toName();
    }
    if (format === "hsl") {
      formattedString = this.toHslString();
    }
    if (format === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  },
  clone: function clone() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color._r;
    this._g = color._g;
    this._b = color._b;
    this.setAlpha(color._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function (color, opts) {
  if (_typeof(color) == "object") {
    var newColor = {};
    for (var i in color) {
      if (color.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color[i];
        } else {
          newColor[i] = convertToPercentage(color[i]);
        }
      }
    }
    color = newColor;
  }
  return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;
  if (typeof color == "string") {
    color = stringInputToObject(color);
  }
  if (_typeof(color) == "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = "hsl";
    }
    if (color.hasOwnProperty("a")) {
      a = color.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok: ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a
  };
}

// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h: h,
    s: s,
    l: l
  };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
  var r, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);
  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    v = max;
  var d = max - min;
  s = max === 0 ? 0 : d / max;
  if (max == min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h: h,
    s: s,
    v: v
  };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h),
    f = h - i,
    p = v * (1 - s),
    q = v * (1 - f * s),
    t = v * (1 - (1 - f) * s),
    mod = i % 6,
    r = [v, q, p, p, t, v][mod],
    g = [t, v, v, q, p, p][mod],
    b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

  // Return a 3 character hex if possible
  if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }
  return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

  // Return a 4 character hex if possible
  if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }
  return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {
  var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
  if (!color1 || !color2) return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};
tinycolor.random = function () {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};

// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function _desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _greyscale(color) {
  return tinycolor(color).desaturate(100);
}
function _lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = tinycolor(color).toRgb();
  rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
  rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
  rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb);
}
function _darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function _spin(color, amount) {
  var hsl = tinycolor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function _complement(color) {
  var hsl = tinycolor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return tinycolor(hsl);
}
function polyad(color, number) {
  if (isNaN(number) || number <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }
  var hsl = tinycolor(color).toHsl();
  var result = [tinycolor(color)];
  var step = 360 / number;
  for (var i = 1; i < number; i++) {
    result.push(tinycolor({
      h: (hsl.h + i * step) % 360,
      s: hsl.s,
      l: hsl.l
    }));
  }
  return result;
}
function _splitcomplement(color) {
  var hsl = tinycolor(color).toHsl();
  var h = hsl.h;
  return [tinycolor(color), tinycolor({
    h: (h + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}
function _analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = tinycolor(color).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color)];
  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(tinycolor(hsl));
  }
  return ret;
}
function _monochromatic(color, results) {
  results = results || 6;
  var hsv = tinycolor(color).toHsv();
  var h = hsv.h,
    s = hsv.s,
    v = hsv.v;
  var ret = [];
  var modification = 1 / results;
  while (results--) {
    ret.push(tinycolor({
      h: h,
      s: s,
      v: v
    }));
    v = (v + modification) % 1;
  }
  return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function (color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba);
};

// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function (color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function (color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);
  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;
    case "AAlarge":
      out = readability >= 3;
      break;
    case "AAAsmall":
      out = readability >= 7;
      break;
  }
  return out;
};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function (baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;
  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);
    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }
  if (tinycolor.isReadable(baseColor, bestColor, {
    level: level,
    size: size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
};

// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);

// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
  var flipped = {};
  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }
  return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
  if (isOnePointZero(n)) n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max, Math.max(0, parseFloat(n)));

  // Automatically convert percentage into number
  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  }

  // Handle floating point rounding errors
  if (Math.abs(n - max) < 0.000001) {
    return 1;
  }

  // Convert into [0, 1] range if it isn't already
  return n % max / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
  return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
  return c.length == 1 ? "0" + c : "" + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }
  return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
var matchers = function () {
  // <http://www.w3.org/TR/css3-values/#integers>
  var CSS_INTEGER = "[-\\+]?\\d+%?";

  // <http://www.w3.org/TR/css3-values/#number-value>
  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

  // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

  // Actual matching.
  // Parentheses and commas are optional, but not required.
  // Whitespace can take the place of commas or opening paren
  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
  return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {
  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  }

  // Try to match string input using regular expressions.
  // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
  // Just return an object and let the conversion functions handle that.
  // This way the result will be the same whether the tinycolor is initialized with string or object.
  var match;
  if (match = matchers.rgb.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }
  if (match = matchers.rgba.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsl.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }
  if (match = matchers.hsla.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsv.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }
  if (match = matchers.hsva.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hex8.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex6.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? "name" : "hex"
    };
  }
  if (match = matchers.hex4.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex3.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function validateWCAG2Parms(parms) {
  // return valid WCAG2 parms for isReadable.
  // If input parms are invalid, return {"level":"AA", "size":"small"}
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();
  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }
  if (size !== "small" && size !== "large") {
    size = "small";
  }
  return {
    level: level,
    size: size
  };
}

class HsbMoveFormula {
    constructor() {
        this.name = 'hsb-move';
        this.args = ['from_color', 'to_color'];
        this.required = ['from_color', 'to_color'];
    }
    generate(args) {
        const from = tinycolor(args.from_color).toHsv();
        const to = tinycolor(args.to_color).toHsv();
        const h = Math.round((360 + to.h - from.h) % 360);
        const s = Math.round(1000 * to.s / from.s) / 1000;
        const b = Math.round(1000 * to.v / from.v) / 1000;
        return {
            css: {},
            filterAttributes: {},
            effects: [{
                    tag: 'feColorMatrix',
                    attributes: {
                        type: 'hueRotate',
                        values: h
                    }
                },
                {
                    tag: 'feColorMatrix',
                    attributes: {
                        type: 'saturate',
                        values: s
                    }
                },
                {
                    tag: 'feColorMatrix',
                    attributes: {
                        type: 'matrix',
                        values: `${b} 0 0 0 0 0 ${b} 0 0 0 0 0 ${b} 0 0 0 0 0 1 0`
                    }
                }]
        };
    }
}

class FloodFillFormula {
    constructor() {
        this.name = 'flood-fill';
        this.args = ['color'];
        this.required = ['color'];
    }
    generate(args) {
        const color = args.color;
        return {
            effects: [{
                    tag: 'feFlood',
                    attributes: {
                        'flood-color': color,
                        'flood-opacity': 1,
                        result: 'flood'
                    }
                }, {
                    tag: 'feComposite',
                    attributes: {
                        in: 'flood',
                        in2: 'SourceGraphic',
                        operator: 'atop'
                    }
                }],
            css: {},
            filterAttributes: {}
        };
    }
}

class BrightnessFormula {
    constructor() {
        this.name = 'brightness';
        this.args = ['brightness'];
        this.required = ['brightness'];
    }
    generate(args) {
        const b = args.brightness;
        return {
            effects: [{
                    tag: 'feColorMatrix',
                    attributes: {
                        type: 'matrix',
                        values: `${b} 0 0 0 0 0 ${b} 0 0 0 0 0 ${b} 0 0 0 0 0 1 0`
                    }
                }],
            css: {},
            filterAttributes: {}
        };
    }
}

class ColorMatrixFormula {
    constructor() {
        this.name = 'color-matrix';
        this.args = ['matrix', 'interpolationColorspace'];
        this.required = ['matrix'];
    }
    generate(args) {
        const matrix = args.matrix;
        if (matrix.split(' ').length !== 20) {
            throw new Error('Matrix not consisting of 20 elements');
        }
        const filterAttributes = args.interpolationColorspace ? {
            'color-interpolation-filters': args.interpolationColorspace
        } : {};
        return {
            effects: [{
                    tag: 'feColorMatrix',
                    attributes: {
                        type: 'matrix',
                        values: matrix
                    }
                }],
            css: {},
            filterAttributes
        };
    }
}

class ColorMatrixBatchFormula {
    constructor() {
        this.name = 'color-matrix-batch';
        this.args = ['matrices', 'color', 'interpolationColorspace'];
        this.required = ['matrices', 'color'];
    }
    generate(args) {
        const matrices = args.matrices;
        const color = args.color;
        const obj = JSON.parse(matrices);
        if (!(color in obj))
            throw new Error(`Color ${color} not found in matrices`);
        const matrix = obj[color];
        if (matrix.split(' ').length !== 20) {
            throw new Error('Matrix not consisting of 20 elements');
        }
        const filterAttributes = args.interpolationColorspace ? {
            'color-interpolation-filters': args.interpolationColorspace
        } : {};
        return {
            effects: [{
                    tag: 'feColorMatrix',
                    attributes: {
                        type: 'matrix',
                        values: matrix
                    }
                }],
            css: {},
            filterAttributes
        };
    }
}

class IllustratorElementTransformer {
    transform(element, $) {
        var _a;
        const el = $(element);
        let id = el.attr('data-name') || el.attr('id');
        if (((_a = el.prop("tagName")) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'svg' && !id) {
            id = 'root';
        }
        else if (!id || el.attr('transfo-id')) {
            return;
        }
        const normalizedId = deillustratorize(id);
        el.attr('transfo-id', normalizedId);
    }
}
function deunicodize(s) {
    for (let i = 0; i <= 256; i++) {
        const n = i.toString(16).toUpperCase();
        s = s.replace(`_x${n}_`, String.fromCharCode(+`0x00${n}`));
    }
    return s;
}
function deillustratorize(id) {
    const md = id.match(/([$\w-]+)_\d+_$/);
    return deunicodize(md ? md[1] : id).replace(' ', '_');
}

class RasterizerIllustratorElementTransformer {
    transform(element, $) {
        var _a;
        const el = $(element);
        let id = el.attr('data-name') || el.attr('id');
        if (((_a = el.prop("tagName")) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'svg' && !id) {
            id = 'root';
        }
        else if (!id || el.attr('transfo-id')) {
            return;
        }
        let normalizedId = deillustratorize(id);
        if (normalizedId.endsWith('!') || el.parent('[id$="&"]').length) {
            el.attr('id', null);
            normalizedId = null;
        }
        else if (normalizedId.endsWith('&') || normalizedId.endsWith('@')) {
            normalizedId = normalizedId.slice(0, -1);
        }
        el.attr('transfo-id', normalizedId);
    }
}

class LegacyNamingElementTransformer {
    transform(element, $) {
        var _a;
        const el = $(element);
        let id = el.attr('data-name') || el.attr('id');
        if (((_a = el.prop("tagName")) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'svg' && !id) {
            id = 'root';
        }
        else if (!id || el.attr('transfo-id')) {
            return;
        }
        let normalizedId = deillustratorize(id);
        if (normalizedId.endsWith('!') || el.parent('[id$="&"]').length) {
            el.attr('id', null);
            normalizedId = null;
        }
        else if (normalizedId.endsWith('&') || normalizedId.endsWith('@')) {
            normalizedId = normalizedId.slice(0, -1);
        }
        el.attr('transfo-id', normalizedId);
    }
}

export { BrightnessFormula, BrowserEvalContext, CashDomWrapper, ChoiceMode, ColorMatrixBatchFormula, ColorMatrixFormula, FloodFillFormula, HsbMoveFormula, IllustratorElementTransformer, InlineCashDomWrapper, LegacyNamingElementTransformer, RasterizerIllustratorElementTransformer, Transfo, XhrDownloader, addExpandedNameToGroups, deillustratorize, expandCollection, expandGroup, expandMutation, flattenGroup, formulaScriptToFormula, getChosenAndUnchosenGroups, getOtherGroupsFromCollectionChoice, groupGlobFilter, isInlineSvg, link };
